export default {
  '(自定义)': '(Custom)',
  '0.15-0.6 双贡针': '0.15-0.6cm Double Stitch',
  '0.15-0.9 双贡针': '0.15-0.9cm Double Stitch',
  '0.15-0.9cm 双贡针': '0.15–0.9cm Double',
  '0.15cm 贡针': '0.15cm Stitch',
  '0.3cm 贡针': '0.3cm Stitch',
  '0.6cm 贡针': '0.6cm Stitch',
  '0.9cm 贡针': '0.9cm Stitch',
  '1 个平叠锁眼 + 1 纽扣': '1 Kissing Flat Buttonhole + 1 Button',
  '1 个平斜锁眼 + 1 纽扣': '1 Slant Flat Buttonhole + 1 Button',
  '1 个平斜锁眼+1 纽扣': '1 Flat Slanted Buttonhole + 1 Button',
  '1 个平锁眼 + 1 纽扣': '1 Flat Buttonhole + 1 Button',
  '1 个斜叠锁眼 + 1 纽扣': '1 Kissing Slanted Buttonhole + 1 Button',
  '2 个平叠锁眼 + 2 纽扣': '2 Kissing Flat Buttonholes + 2 Buttons',
  '2 个平斜锁眼 + 2 纽扣': '2 Slant Flat Buttonholes + 2 Buttons',
  '2 个平斜锁眼+2 纽扣': '2 Flat Slanted Buttonholes + 2 Buttons',
  '2 个平锁眼 + 2 纽扣': '2 Flat Buttonholes + 2 Buttons',
  '2 个斜叠锁眼 + 2 纽扣': '2 Kissing Slanted Buttonholes + 2 Buttons',
  '2 件套': '2-PCS',
  '2 次代用料毛样': '2nd Quick Muslin Fitting',
  '2件套': '2-PCS',
  '2次代用料': '2nd Substitute Fabric',
  '3 个平叠锁眼+3 纽扣': '3 Kissing Flat Buttonholes + 3 Buttons',
  '3 个平斜锁眼+3 纽扣': '3 Flat Slanted Buttonholes + 3 Buttons',
  '3 个平锁眼 + 3 纽扣': '3 Flat Buttonholes + 3 Buttons',
  '3 个平锁眼+3 纽扣': '3 Flat Buttonholes + 3 Buttons',
  '3 个斜叠锁眼+3 纽扣': '3 Kissing Slanted Buttonholes + 3 Buttons',
  '3 个贴袋': '3 Patch Pockets',
  '3 件套': '3-PCS',
  '3件套': '3-PCS',
  '3粒': '3 Buttons',
  '4 个平叠锁眼+4 纽扣': '4 Kissing Flat Buttonholes + 4 Buttons',
  '4 个平斜锁眼+4 纽扣': '4 Flat Slanted Buttonholes + 4 Buttons',
  '4 个平锁眼 + 4 纽扣': '4 Flat Buttonholes + 4 Buttons',
  '4 个平锁眼+4 纽扣': '4 Flat Buttonholes + 4 Buttons',
  '4 个斜叠锁眼+4 纽扣': '4 Kissing Slanted Buttonholes + 4 Buttons',
  '5 个平叠锁眼+5 纽扣': '5 Kissing Flat Buttonholes + 5 Buttons',
  '5 个平斜锁眼+5 纽扣': '5 Flat Slanted Buttonholes + 5 Buttons',
  '5 个平锁眼 + 5 纽扣': '5 Flat Buttonholes + 5 Buttons',
  '5 个平锁眼+5 纽扣': '5 Flat Buttonholes + 5 Buttons',
  '5 个斜叠锁眼+5 纽扣': '5 Kissing Slanted Buttonholes + 5 Buttons',
  '5.5cm 袋盖': '5.5cm Flap',
  '5粒': '5 Buttons',
  '6 个平叠锁眼+6 纽扣': '6 Kissing Flat Buttonholes + 6 Buttons',
  '6 个平斜锁眼+6 纽扣': '6 Flat Slanted Buttonholes + 6 Buttons',
  '6 个平锁眼 + 6 纽扣': '6 Flat Buttonholes + 6 Buttons',
  '6 个平锁眼+6 纽扣': '6 Flat Buttonholes + 6 Buttons',
  '6 个斜叠锁眼+6 纽扣': '6 Kissing Slanted Buttonholes + 6 Buttons',
  '6.5cm 袋盖': '6.5cm Flap',
  '6粒': '6 Buttons',
  '7.5cm 袋盖': '7.5cm Flap',
  '8.5cm 袋盖': '8.5cm Flap',
  'AI 校验建议': 'AI Validation Suggestions',
  'AI 正面': 'AI Front',
  'AI 渲染预览': 'AI Render Preview',
  '生成AI预览图': 'Generate AI Preview',
  '正在生成中...': 'Generating...',
  'AI 生成最终款式图': 'AI Preview',
  'AI校验功能开发中': 'AI validation feature under development',
  'AI生成款式图（正面）': 'AI Style (Front)',
  'API 配置': 'API Settings',
  'A字裙': 'A-Line Skirt',
  'B端门店订单管理系统': 'B2B Order System',
  'CM': 'CM',
  'CMT工艺费（USD）': 'CMT Labour Only (USD)',
  'FT': 'FT',
  'IP 地址': 'IP Address',
  'KG': 'KG',
  'LB': 'LB',
  'LOGO': 'Logo',
  'Logo上传成功': 'Logo uploaded successfully',
  'POLO 门襟 3.5cm（门襟 3 扣）': 'Polo Placket 3.5cm (3 Buttons)',
  'POLO 门襟 3cm（门襟 3 扣）': 'Polo Placket 3cm (3 Buttons)',
  'RTW成衣': 'Ready-to-Wear (RTW)',
  'RTW成衣价格表': 'RTW Volume Price List',
  'V 型开口': 'V-shape Opening',
  'V 领': 'V-neckline',
  'YYYY-MM-DD': 'YYYY-MM-DD',
  'YYYY-MM-DD HH:mm': 'YYYY-MM-DD HH:mm',
  'YYYY/M/D': 'YYYY/M/D',
  'ai建议': 'AI Suggestion',
  '— CM': '— CM',
  '— KG': '— KG',
  '⚠️ 折扣低于审批红线': '⚠️ Discount below approval threshold',
  '、': ', ',
  '一字半里（包边）': 'Straight 1/4 Half Lining (Bound)',
  '一字半里（贡针）': 'Straight 1/4 Half Lining (Pick Stitch)',
  '一字胸袋+下单开线袋': 'Welt Chest + Single Welt Lower',
  '一字胸袋+下双开线袋': 'Welt Chest + Double Welt Lower',
  '一字胸袋+下贴袋': 'Welt Chest + Patch Lower',
  '一字领（外弧 CUTAWAY）': 'Cutaway Collar',
  '一片领': 'One-piece Collar',
  '一金（住房公积金）': 'Housing Fund',
  '三件套西装': '3-Piece Suit',
  '三步完成客户量体订单': '3-step order',
  '上一字胸袋+下双线袋有袋盖': 'Welt Chest + Flapped Double Welt Lower',
  '上一步': 'Back',
  '上下都无口袋': 'No Pockets',
  '上传': 'Upload',
  '上传Logo': 'Upload Logo',
  '上传体型照': 'Upload Photos',
  '上传凭证': 'Upload Receipt',
  '上传功能开发中': 'Upload in dev',
  '上传图片': 'Upload Image',
  '上传失败': 'Upload failed',
  '上传失败，请检查网络': 'Upload failed, please check your network',
  '上左右一字袋+下左右一字袋': 'Both-side Welt Chest + Both-side Welt Lower',
  '上弧形': 'Upper Curve Milanese',
  '上衣 + 马甲': 'Jacket + Vent',
  '上衣+马甲': 'Jacket + Vent',
  '上衣尺寸': 'Jacket',
  '上衣设计': 'Jacket Design',
  '上衣设计尺寸': 'Jacket Design Size',
  '上衣部位': 'Part',
  '上衣长短习惯': 'Jacket Length Habit',
  '下一步': 'Next',
  '下单': 'Order',
  '下单日期': 'Order Date',
  '下单日期从': 'Order Date From',
  '下单日期到': 'Order Date To',
  '完成日期从': 'Completed From',
  '完成日期到': 'Completed To',
  '下单日期（B 端）': 'MM/DD/YYYY',
  '下口袋袋盖高度': 'Flap Height',
  '下圆青果领': 'Dropped Round Shawl',
  '下弧形': 'Lower Curve Milanese',
  '下摆型': 'Bottom Style',
  '下载': 'Download',
  '不可拆卸插片': 'Fixed Collar Stays',
  '不合格原因': 'Defect Reason',
  '不合格数量': 'Failed Qty',
  '不是图片文件': 'Not an image file',
  '不试身': 'No Fitting',
  '专业能力': 'Professionalism',
  '业务员': 'Sales Staff',
  '业务经理': 'Sales Manager',
  '两件套西装': '2-Piece Suit',
  '两次输入的密码不一致': 'The two passwords do not match',
  '个人信息': 'Personal Info',
  '个人分红': 'Personal Dividend',
  '个人所得税': 'Income Tax',
  '个人提成阶梯': 'Personal Commission Tiers',
  '个人资料': 'Profile',
  '个性收费': 'Customizations',
  '个性收费合计': 'Extra Charges Total',
  '个性收费项配置': 'Extra Item Config',
  '个选项': ' options',
  '个面料': ' fabrics',
  '中圆青果领': 'Medium Round Shawl',
  '中文': 'Chinese',
  '中腰': 'Waist/Stomach',
  '中英双语': 'Bilingual',
  '中长款': 'Mid-Length',
  '中长裙': 'Midi Skirt',
  '主题': 'Theme',
  '争议处理': 'Dispute',
  '事事如意': 'Everything Goes Well',
  '五险（保险）': 'Social Insurances',
  '亚麻': 'Linen',
  '亚麻系列': 'Linen',
  '交易日期': 'Transaction Date',
  '产品': 'Product',
  '人民币参考': '¥X,XXX.XX',
  '仅复用客户信息': 'Copy Client Info Only',
  '仅复用款式': 'Copy Style Only',
  '今日新增订单': 'New Orders Today',
  '从样衣库中选择已有款式，一键下单': 'Select from the sample library, one-click order',
  '付款': 'Payment',
  '付款信息': 'Payment Info',
  '付款审核': 'Payment Review',
  '付款审核中': 'Payment Review',
  '付款已确认': 'Payment Confirmed',
  '付款异常': 'Payment Exception',
  '付款方式': 'Payment Terms',
  '付款日期': 'Payment Date',
  '付款状态': 'Payment Status',
  '付款记录': 'Payment History',
  '代理': 'Agent',
  '代用料手工毛样': 'Handmade Quick Muslin Fitting',
  '代用料毛样': 'Quick Muslin Fitting',
  '代采购': 'Agency Order',
  '以下品类尚未选择面料：': 'Missing fabric: ',
  '以下设计项尚未选择：': 'The following design items have not been selected:',
  '价格': 'Price',
  '价格体系': 'Pricing',
  '价格如有变动，恕不另行通知。': 'Prices are subject to change without prior notice.',
  '价格档': 'Grade',
  '价格档次': 'Price Grade',
  '价格等级表': 'Price Grade Table',
  '价格说明': 'Price Note',
  '优先 10天': 'Priority 10d',
  '优先10天': 'Priority 10d',
  '优先级': 'Priority',
  '优先（10 天）': 'Priority (10 days)',
  '优惠活动': 'Promotions',
  '伸缩调节袢纽扣': 'Elastic Adjuster with Button',
  '位置': 'Position',
  '低腰': 'Low Rise',
  '住房公积金': 'Housing Fund',
  '体型照': 'Body Photos',
  '体型及尺寸档案': 'Measurement History',
  '体型和款式图': 'Body & Style Photos',
  '体型描述': 'Body Description',
  '体型照/特殊设计照': 'Body Photos',
  '体型照片已匹配': 'Body photos matched',
  '体型特征': 'Body Profile',
  '体型特征分析': 'Body Feature Analysis',
  '体重': 'Weight',
  '体重(kg)': 'Weight(kg)',
  '体重超出正常范围，请检查修改。': 'Weight seems unusual. Please double-check.',
  '余款须在发货前结清。': 'The balance must be settled before shipment.',
  '例如：退货、换货、维修': 'e.g. Return, Exchange, Repair',
  '供应商': 'Supplier',
  '供应商对账单': 'Supplier Statements',
  '侧伸缩腰': 'Side Elastic Waist',
  '侧开叉': 'Side Vent',
  '侧松紧腰': 'Side Elastic Waist Band',
  '侧缝顺色哑光色丁 1.5cm': 'Side Matching Matte Satin 1.5cm',
  '侧缝顺色哑光色丁 2.5cm': 'Side Matching Matte Satin 2.5cm',
  '侧缝黑色哑光色丁 1.5cm': 'Side Black Matte Satin 1.5cm',
  '侧缝黑色哑光色丁 2.5cm': 'Side Black Matte Satin 2.5cm',
  '侧面': 'Side',
  '保存': 'Save',
  '保存修改': 'Save Changes',
  '保存成功': 'Saved',
  '信息已更新（演示）': 'Updated (demo)',
  '信用额度': 'Credit Limit',
  '信用额度管理': 'Credit Limits',
  '修改密码': 'Change Password',
  '修改费': 'Alteration Fee',
  '修身': 'Slim',
  '倒缝袖（垫肩 0.1cm + 单层棉条 + 自然褶）': 'Spalla Camicia (0.1cm pad, natural pleats)',
  '倒缝袖（无垫肩 + 无棉条 + 自然褶）': 'Spalla Camicia (No padding, natural pleats)',
  '假袖叉假锁眼': 'Non-functional Vent (Non-functional Buttonhole)',
  '假袖叉圆头锁眼': 'Non-functional Vent (Functional Buttonhole)',
  '假袖叉圆弧翻边（4.5cm）': 'Non-functional Vent + Functional Buttonhole + Curved Turn-up 4.5cm',
  '假袖叉圆弧翻边（7.5cm）': 'Non-functional Vent + Functional Buttonhole + Curved Turn-up 7.5cm',
  '假袖叉无锁眼': 'Non-functional Vent (No Buttonhole)',
  '假袖叉直翻边（4.5cm）': 'Non-functional Vent + Functional Buttonhole + Straight Turn-up 4.5cm',
  '假袖叉直翻边（7.5cm）': 'Non-functional Vent + Functional Buttonhole + Straight Turn-up 7.5cm',
  '停用': 'Inactive',
  '催款通知': 'Overdue Reminder',
  '充值': 'Recharge',
  '充值 / 退款金额': 'Deposit/Refund',
  '充值记录': 'Recharge History',
  '光门襟 3.5cm': 'French Placket 3.5cm',
  '光门襟 3cm': 'French Placket 3cm',
  '克重': 'Weight (gsm)',
  '免熨系列': 'Wrinkle-free',
  '免费系列': 'Free Lining',
  '入门档': 'BASIC / Entry',
  '全体员工总权重': 'Total Weight',
  '全勤': 'Attendance Bonus',
  '全手工': 'Full Bespoke',
  '全手工全麻衬厚胸衬': 'Full Handmade Full Canvas (Heavy)',
  '全手工全麻衬薄胸衬': 'Full Handmade Full Canvas (Light&Soft)',
  '全松紧腰': 'Full Elastic Waist',
  '全松紧（前门襟无松紧）': 'Full Elastic (No Fly Elastic)',
  '全衬': 'Full Canvas',
  '全裤袢 10 个 1cm': '10 Belt Loops (1cm)',
  '全裤袢 2cm': 'Full Belt Loops (2cm)',
  '全裤袢 6 个 1cm': '6 Belt Loops (1cm)',
  '全裤袢 7 个 1cm': '7 Belt Loops (1cm)',
  '全裤袢 8 个 1cm': '8 Belt Loops (1cm)',
  '全贡针': 'Full Stitch',
  '全部': 'All',
  '全部信息': 'All Info',
  '全部完成': 'All Done',
  '全部订单': 'All Orders',
  '全里': 'Full Lining',
  '全麻衬厚胸衬': 'Full Canvas (Heavy)',
  '全麻衬薄胸衬': 'Full Canvas (Light&Soft)',
  '公司仓库': 'JD Warehouse',
  '公告': 'Announcement',
  '共享数据': 'Shared Data',
  '关税': 'Duties',
  '关联单号': 'Related Order #',
  '关联工厂': 'Link Factories',
  '关闭': 'Close',
  '其他': 'Other',
  '其他奖金': 'Other Bonus',
  '其他成员团单合计': 'Team RTW Sales (Others)',
  '其他成员定制单合计': 'Team MTM Sales (Others)',
  '其他扣款': 'Other Deductions',
  '其他费用': 'Other Fees',
  '其它费用': 'Other',
  '内容': 'Content',
  '内折 5cm': 'Inner Hem 5cm',
  '内折 7cm': 'Inner Hem 7cm',
  '内滚条': 'Inner Piping',
  '内袋款式': 'Inner Pocket Style',
  '内袖口撞色': 'Inner Cuffs Contrast',
  '内贡针及贡针线': 'Inner Pick Stitch & Thread',
  '内过肩撞色': 'Inner Yoke Contrast',
  '内门襟撞色': 'Inner Placket Contrast',
  '内领+内袖口+内门襟撞色': 'Inner Collar + Inner Cuffs + Inner Placket Contrast',
  '内领+内袖口撞色': 'Inner Collar + Inner Cuffs Contrast',
  '内领底居中': 'Under Collar Center',
  '内领撞色': 'Inner Collar Contrast',
  '冬季': 'Winter',
  '净尺寸': 'Body',
  '准直胸袋': 'Welt Chest Pocket',
  '减少': 'Decrease',
  '减少品类信息将丢失': 'Removing categories will discard associated data',
  '减少品类将丢失该品类的设计信息': 'Lose design if removed',
  '凭证号': 'Ref No',
  '凭证截图': 'Receipt',
  '出生日期': 'Date of Birth',
  '出货日期': 'Delivery Date',
  '出货期': 'Finished Date',
  '出货通知': 'Shipping Notification',
  '分红年份': 'Dividend Year',
  '分红池比例': 'Dividend Pool Ratio',
  '切角 1 眼 2 扣': 'Angled 1-Buttonhole 2-Buttons',
  '切角 2 用': 'Angled Convertible Cuff',
  '切角 2 眼 2 扣': 'Angled 2-Buttonholes 2-Buttons',
  '创建失败': 'Create Failed',
  '创建新订单': 'New Order',
  '创建时间': 'Created At',
  '创建订单失败': 'Failed to create order',
  '删除': 'Delete',
  '删除此刺绣': 'Delete this embroidery',
  '刷新': 'Refresh',
  '刷新页面': 'Refresh Page',
  '刺绣': 'Embroidery',
  '刺绣位置': 'Embroidery Placement',
  '刺绣内容': 'Embroidery Content',
  '刺绣备注': 'Embroidery Notes',
  '刺绣姓名缩写': 'Monogram Embroidery',
  '刺绣字体': 'Embroidery Font',
  '刺绣类型': 'Embroidery Type',
  '刺绣设计': 'Embroidery',
  '刺绣高度': 'Embroidery Height',
  '前后全里': 'Full Lining',
  '前后半里': 'Full Half Lining',
  '前挺缝线': 'Front Crease',
  '前浪': 'Front Rise',
  '前片全里': 'Front Full Lining',
  '前片半里': 'Front Half Lining',
  '前片设计': 'Front Design',
  '前片贴布': 'Front Placket Fabric',
  '前端分类项配置': 'Frontend Category Order',
  '前胸宽': 'Chest Width (Front)',
  '前腰节': 'Front Waist Length',
  '前腰节长': 'Front Waist Length',
  '前长': 'Front Length',
  '前领 1 个纽扣': '1-Button Collar Stand',
  '前领 2 个纽扣': '2-Button Collar Stand',
  '剪刀型': 'Scissors Shape Milanese',
  '加入购物车': 'Add to Cart',
  '加急': 'Urgent',
  '加急 5天': 'Urgent 5d',
  '加急 7天': 'Urgent 7d',
  '加急5天': 'Urgent 5d',
  '加急3天': 'Urgent 3d',
  '加急7天': 'Urgent 7d',
  '加急单': 'Urgent Orders',
  '加急单数量': 'Rush Orders',
  '加急处理，确保15日前到达上海办公室。': 'Urgent processing, ensure arrival at Shanghai office before the 15th.',
  '加急费': 'Rush Order Fee',
  '加急（7 天）': 'Rush (7 days)',
  '加载中…': 'Loading…',
  '加载设计项...': 'Loading design items...',
  '包装升级': 'Premium Packaging',
  '千克': 'kg',
  '半圆形半里（包边）': 'Half Rounded Half Lining (Bound)',
  '半圆形半里（贡针）': 'Half Rounded Half Lining (Pick Stitch)',
  '半手工半麻衬厚胸衬': 'Semi-Handmade Half Canvas (Heavy)',
  '半手工半麻衬薄胸衬': 'Semi-Handmade Half Canvas(Light&Soft)',
  '半手工无结构无胸衬': 'Semi-Handmade Unstructured (No Canvas)',
  '半衬': 'Half Canvas',
  '半贡针': 'Half Stitch',
  '常规里袋+水滴笔袋': 'Standard Inner Pocket + Teardrop Pen Pocket',
  '常规里袋+一字笔袋': 'Standard Inner Pocket + Pen Pocket',
  '常规里袋+一字笔袋+卡袋': 'Standard Inner Pocket + Pen Pocket + Card Pocket',
  '常规里袋+水滴笔袋+卡袋': 'Standard Inner Pocket + Teardrop Pen Pocket + Card Pocket',
  '半身裙': 'Skirt',
  '半麻衬厚胸衬': 'Half Canvas (Heavy)',
  '半麻衬薄胸衬': 'Half Canvas (Light&Soft)',
  '半麻衬工艺': 'Half Canvas',
  '单 6 扣': '6-Button Single Breasted',
  '单上衣': 'Jacket Only',
  '单价': 'Unit Price',
  '单价（USD）': 'Price (USD)',
  '单位': 'Unit',
  '单大衣': 'Overcoat Only',
  '单开线竖口袋': 'Vertical Single Welt Pocket',
  '单开线袋+锁眼钉扣': 'Single Welt + Buttonhole & Button',
  '单开线袋（无眼无扣）': 'Single Welt (No Buttonhole)',
  '单开衩': 'Single Vent',
  '单扣袖口': 'Single Cuff',
  '单排 1 粒对拉扣': '1 Wrap',
  '单排 1 粒扣': '1 SB',
  '单排 2 粒扣': '2 SB',
  '单排 3 扣': '3-Button Single Breasted',
  '单排 3 扣 2': '3/2,SB',
  '单排 3 粒扣': '3 SB',
  '单排 4 扣': '4-Button Single Breasted',
  '单排 5 扣': '5-Button Single Breasted',
  '单独发': 'Ship Separately',
  '单省道': 'Single Dart',
  '单线袋': 'Single Besom Pocket',
  '单线袋（1.2cm）': 'Single Besom (1.2cm)',
  '单衬衫': 'Shirt Only',
  '单褶': 'Single Pleat',
  '单褶向内': 'Single Reverse Pleat',
  '单褶向内+手工套结': 'Single Reverse Pleat + Hand Bartack',
  '单褶向外': 'Single Forward Pleat',
  '单褶向外+手工套结': 'Single Forward Pleat + Hand Bartack',
  '单西裙': 'Skirt Only',
  '单西裙（女装）': 'Skirt(Women)',
  '单西裤': 'Trousers Only',
  '单边宝剑头调节袢': 'Single-side Normal Adjuster',
  '单边小弧形调节袢': 'Single-side Curved Adjuster',
  '单边廓尔格腰': 'Single Gurkha Waistband',
  '卡袋上订商标 + 面料标': 'Brand + Fabric Label on Card Pocket',
  '卡袋上订商标+面料标': 'Brand + Fabric Label on Card Pocket',
  '厘米': 'cm',
  '厚羊毛': 'Heavy Wool',
  '去结算': 'Checkout',
  '参考值': 'Guide',
  '参考图片': 'Reference Image',
  '参考成衣尺寸': 'Ref Garment Size',
  '参考汇率': 'Exchange Rate (USD→CNY)',
  '及膝': 'Knee Length',
  '双开叉无防风条': 'Double Vent (No Vent Stay)',
  '双开叉防风条': 'Double Vent (Vent Stay)',
  '双开线竖口袋': 'Vertical Double Welt Pocket',
  '双开线袋': 'Jetted Pocket',
  '双开线袋+圆扣袢+锁眼钉扣': 'Double Welt + Round Tab + Buttonhole & Button',
  '双开线袋+锁眼钉扣': 'Double Welt + Buttonhole & Button',
  '双开线袋（无眼无扣）': 'Double Welt (No Buttonhole)',
  '双开衩': 'Double Vent',
  '双排 2 扣 1': '2x1 DB',
  '双排 4 扣 2': '4x2 DB',
  '双排 4 扣 2+尖下摆': 'DB 4×2 + Pointed Hem',
  '双排 5 扣 3 斜门襟': 'DB 5×3 Diagonal Fly',
  '双排 6 扣 1': '6x1 DB',
  '双排 6 扣 2': '6x2 DB',
  '双排 6 扣 2+尖下摆': 'DB 6×2 + Pointed Hem',
  '双排 6 扣 3': '6x3 DB',
  '双排 6 扣 3 斜门襟+尖下摆': 'DB 6×3 Diagonal Fly + Pointed Hem',
  '双排 6 扣 3+尖下摆': 'DB 6×3 + Pointed Hem',
  '双排 8 扣 4': '8x4 DB',
  '双排 8 扣 4+尖下摆': 'DB 8×4 + Pointed Hem',
  '双省道': 'Double Darts',
  '双线大袋（有袋盖）+ 一字票袋（无袋盖）': 'Flapped Double Besom + Welt Ticket Pocket',
  '双线大袋（有袋盖）+ 双线票袋（有袋盖）': 'Flapped Double Besom + Ticket Pocket (Flap)',
  '双线大袋（直角袋盖）+双线票袋（直角袋盖）': 'Double Besom (Square Flap) + Double Besom Ticket (Square Flap)',
  '双线袋': 'Double Besom Pocket',
  '双线袋 + 小圆直袋盖': 'Double Besom + Standard Flap',
  '双线袋无袋盖': 'Double Besom without Flap',
  '双线袋（无盖）+ 双线票袋（无盖）': 'Double Besom (No flap) + Double Besom Ticket (No flap)',
  '双褶': 'Double Pleat',
  '双褶向内': 'Double Reverse Pleats',
  '双褶向内+手工套结': 'Double Reverse Pleats + Hand Bartack',
  '双褶向外+手工套结': 'Double Forward Pleats + Hand Bartack',
  '双褶外': 'Double Forward Pleats',
  '双边廓尔格腰': 'Double Gurkha Waistband',
  '发票': 'Invoice',
  '发票信息': 'Invoice Info',
  '发票号': 'Invoice #',
  '发票管理': 'Invoice Mgmt',
  '发票记录': 'Invoice Records',
  '发货中': 'Shipping',
  '发货单': 'Shipping Note',
  '发货日期': 'Ship Date',
  '发货管理': 'Outgoing',
  '发送': 'Send',
  '发送失败': 'Send failed',
  '发送状态': 'Sent Status',
  '发送给供应商': 'Send to Supplier',
  '取消': 'Cancel',
  '取消订单': 'Cancel Order',
  '取消订单失败，请联系客服。': 'We couldn\'t cancel this order. Please contact your designer.',
  '口袋': 'Pocket',
  '古巴领': 'Cuban Collar',
  '可拆卸插片': 'Removable Collar Stays',
  '可用': 'Available',
  '可用余额': 'Available Balance',
  '可用额度': 'Available Credit',
  '右 3': 'Right 3',
  '右前 1 个裤袢 1cm': '1 Right-front Belt Loop (1cm)',
  '右前 1 个裤袢 2cm': '1 Right-front Belt Loop (2cm)',
  '右前片下腰口': 'Right Front Below Waistband',
  '右前腰部（第 4 个纽扣右侧）': 'Right Front Waist (Right of 4th Button)',
  '右单开线袋+锁眼钉扣': 'Right Single Welt + Buttonhole & Button',
  '右单开线袋（无眼无扣）': 'Right Single Welt (No Buttonhole)',
  '右双开线袋+桃型袋盖': 'Right Double Welt + Rounded Flap',
  '右双开线袋+菱形袋盖': 'Right Double Welt + Diamond Flap',
  '右双开线袋+锁眼钉扣': 'Right Double Welt + Buttonhole & Button',
  '右双开线袋（无眼无扣）': 'Right Double Welt (No Buttonhole)',
  '右开线袋+圆扣袢+锁眼钉扣': 'Right Welt + Round Tab + Buttonhole & Button',
  '右手腕': 'Right Wrist',
  '右挂面袋上居中': 'Right Facing Pocket',
  '右腰线上双线袋+右袋布内': 'Right Waist Double Welt +Inside Right Pocket',
  '右腰线上双线袋+左袋布内': 'Right Waist Double Welt + Inside Left Pocket',
  '右腰缝上一字袋+右袋布内': 'Right Seam Welt + Inside Right Pocket',
  '右腰缝上一字袋+左袋布内': 'Right Seam Welt + Inside Left Pocket',
  '右腰里刺绣': 'Right Waistband Inside Embroidery',
  '右腰里订商标': 'Brand Label – Right Waistband Inside',
  '右腰里订面料标': 'Fabric Label – Right Waistband Inside',
  '右腰顶开缝袋': 'Right Waist Top Seam Pocket',
  '右表袋+桃型袋盖+锁眼钉扣': 'Right Watch Pocket + Rounded Flap + Button',
  '右表袋+菱形袋盖+锁眼钉扣': 'Right Watch Pocket + Diamond Flap + Button',
  '右袖口': 'Right Cuff',
  '右袖长': 'Right Sleeve Length',
  '右里袋上居中': 'Right Inner Pocket',
  '右驳头眼顺边绣': 'Right Lapel Buttonhole Edge Embroidery',
  '合体': 'Regular',
  '合体要求': 'Fit',
  '合作年限': 'Partnership Years',
  '合作状态': 'Partnership Status',
  '合作等级': 'Rating (1-5)',
  '合并发票': 'Combined Invoice',
  '合格数量': 'Passed Qty',
  '同上衣': 'Same as Jacket',
  '同主品类': 'Same as Main Piece',
  '同上衣里布': 'Same as Jacket',
  '同大身': 'Same as Body',
  '同西服上衣': 'Same as Jacket',
  '名称': 'Name',
  '后中衩': 'Center Vent',
  '后中长': 'Back Center Length',
  '后台日期': 'YYYY-MM-DD',
  '后尖角贴袋': 'Back Pointed Patch Pocket',
  '后开叉型': 'Back Vent',
  '后开衩': 'Vent',
  '后背': 'Back',
  '后片省': 'Back Darts',
  '后片设计': 'Back Style',
  '后背内工字褶': 'Hidden Box Pleat',
  '后背双褶': 'Double Back Pleats',
  '后背双褶+双省': 'Double Back Pleats + Double Darts',
  '后背宽': 'Back Width',
  '后背明工字褶': 'Visible Box Pleat',
  '后背明工字褶+双省': 'Visible Box Pleat + Double Darts',
  '后背用料': 'Back Fabric',
  '后腰开口': 'Back Waistband Opening',
  '后腰节': 'Back Waist Length',
  '后腰节长': 'Back Waist Length',
  '后表袋+桃型袋盖+暗锁眼钉扣': 'Back Watch Pocket + Rounded Flap + Hidden Button',
  '后表袋+菱形袋盖+暗锁眼钉扣': 'Back Watch Pocket + Diamond Flap + Hidden Button',
  '后领底尼上口居中': 'Under Collar – Top',
  '后领底尼下口居中': 'Under Collar – Bottom',
  '启用': 'Enable',
  '员工': 'Employee',
  '员工分红比例': 'Employee Dividend Ratio',
  '员工工资汇总': 'Payroll',
  '周一': 'Monday',
  '周三': 'Wednesday',
  '周二': 'Tuesday',
  '周五': 'Friday',
  '周六': 'Saturday',
  '周四': 'Thursday',
  '周日': 'Sunday',
  '咖啡色纯亚麻': 'Coffee Pure Linen',
  '品牌': 'Brand',
  '品牌名称': 'Brand Name',
  '品类': 'Category',
  '品类选择': 'Category',
  '品类配置': 'Category Config',
  '品质': 'Quality',
  '响应速度': 'Responsiveness',
  '售后': 'After-sales',
  '售后信息': 'After-sales Info',
  '售后单号': 'AS No',
  '售后原因': 'After-sales Reason',
  '售后工单': 'After-sales Tickets',
  '售后沟通': 'After-sales Communication',
  '售后状态': 'After-sales Status',
  '售后申请': 'After-sales Request',
  '售后申请失败，请稍后重试。': 'Something went wrong. Please try again.',
  '售后申请已提交': 'After-sales request submitted',
  '售后管理': 'Support Requests',
  '售后类型': 'After-sales Type',
  '售后记录': 'After-sales History',
  '售后说明': 'After-sales Description',
  '商标': 'Labels',
  '商标 + 领标': 'Brand + Neck Label',
  '商标+领标': 'Brand Label + Collar Label',
  '商标及码标都订后复势': 'Brand + Size Label on Back Yoke',
  '商标在右': 'Brand Label Right',
  '商标在左': 'Brand Label Left',
  '商标订下里襟': 'Label on Under Placket',
  '商标订卡袋上': 'Brand Label on Card Pocket',
  '商标订后复势': 'Label on Back Yoke',
  '商标订后复势+面料标订下里襟': 'Brand on Back Yoke + Fabric on Under Placket',
  '四季': 'All Season',
  '团单提成率': 'RTW Commission Rate',
  '团队管理提成': 'Team Management Commission',
  '团队管理提成率': 'Team Management Rate',
  '国家/地区': 'Country',
  '图文': 'Graphic Text',
  '放大': 'Zoom',
  '图案': 'Pattern',
  '图片': 'Image',
  '图片上传失败，请检查文件格式和大小。': 'Couldn\'t upload image. Please check file type and size.',
  '图片上传成功': 'Image uploaded successfully',
  '图片刺绣': 'Image Embroidery',
  '圆头 5cm+暗钩': 'Rounded Tip 5cm + Hook & Bar',
  '圆头 5cm+锁眼钉扣': 'Rounded Extension 5cm + Buttonhole & Button',
  '圆形牛仔袋（又名月牙袋）': 'Curved Denim Pocket',
  '圆形青果领': 'Full Round Shawl',
  '圆摆': 'Rounded Hem',
  '圆肩': 'Round Shoulder',
  '圆角 1 眼 2 扣': 'Rounded 1-Buttonhole 2-Buttons',
  '圆角 2 用': 'Rounded Convertible Cuff',
  '圆角 2 眼 2 扣': 'Rounded 2-Buttonholes 2-Buttons',
  '圆角立领': 'Mandarin Collar (Band Collar)',
  '圆角领': 'Round Collar',
  '圆贴布中褶': 'Curved Placket – Medium Tuck',
  '圆贴布大褶': 'Curved Placket – Large Tuck',
  '圆贴布小褶（塔克）': 'Curved Placket – Small Tuck',
  '圆贴布无褶': 'Curved Placket – No Tuck',
  '在右袋布内': 'Inside Right Pocket',
  '在左右袋布内': 'Inside Both Pocket',
  '在左袋布内': 'Inside Left Pocket',
  '在线': 'Online',
  '地址': 'Address',
  '城市': 'City',
  '基准价': 'Default Price',
  '基本信息': 'Basic Info',
  '基本工资': 'Base Salary',
  '基础价格': 'Base Price',
  '基础价格表': 'Base Price List',
  '基础围度已完成': 'Base measurements completed',
  '基础金额': 'Base Amount',
  '增加': 'Increase',
  '处理': 'Process',
  '处理中': 'In Progress',
  '处理方式': 'Action',
  '处罚规则': 'Penalty Rules',
  '备注': 'Notes',
  '备注已对门店可见': 'Note is now visible to customers',
  '备注已隐藏': 'Note is now hidden',
  '点击隐藏此备注': 'Click to hide this note',
  '点击显示此备注': 'Click to show this note',
  '备注与特殊说明': 'Remarks & Special Instructions',
  '备注信息': 'Remarks',
  '备注（可选）': 'Remarks (Optional)',
  '备货': 'Restock',
  '备货中': 'Pre-order',
  '复制': 'Copy',
  '复制旧订单': 'Duplicate from Existing',
  '复制订单': 'Duplicate Order',
  '复制订单失败': 'Copy order failed',
  '复制链接': 'Copy Link',
  '复用全部信息': 'Copy All',
  '复用旧订单': 'Use Existing',
  '复用旧订单尺寸': 'Reuse Measurements',
  '夏季': 'Summer',
  '外翻 3.5cm': 'Turn-up Cuff 3.5cm',
  '外翻 3cm': 'Turn-up Cuff 3cm',
  '外翻 5.5cm': 'Turn-up Cuff 5.5cm',
  '外翻 5cm': 'Turn-up Cuff 5cm',
  '外翻 6cm': 'Turn-up Cuff 6cm',
  '外裤长': 'Outseam',
  '外贡针线': 'Outer Pick Stitch Thread',
  '外过肩撞色': 'Outer Yoke Contrast',
  '外领面居中': 'Outer Collar Center',
  '多个标签用逗号分隔': 'Comma separated tags',
  '大 U 型': 'Large U-neckline',
  '大八字领': 'Wide Spread Collar',
  '大圆型下摆': 'Large Round Hem',
  '大挂面': 'Wide Facing',
  '大挂面无里（包边）': 'Wide Facing Unlined (Bound)',
  '大挂面无里（贡针）': 'Wide Facing Unlined (Pick Stitch)',
  '大挂面（适合无里布工艺）': 'Large Facing (for unlined)',
  '大腿围': 'Thigh',
  '大衣': 'Overcoat',
  '大衣尺寸': 'Coat',
  '大衣设计': 'Coat Design',
  '大衣设计尺寸': 'Coat Design Size',
  '大衣部位': 'Part',
  '天': 'Days',
  '天然混纺系列': 'Natural Blend',
  '奖励通知': 'Reward Notification',
  '套装内所有品类使用相同面料，如需不同面料请分开下单': 'All categories in the set use the same fabric. Please place separate orders for different fabrics.',
  '奢华档': 'LUXURY',
  '奢华档（高）': 'LUXURY (High)',
  '女': 'Female',
  '如：150': 'e.g. 150',
  '如：2026-04 量体': 'e.g. 2026-04',
  '如：3': 'e.g. 3',
  '如：DHL / FedEx': 'e.g. DHL/FedEx',
  '如：DHL、顺丰': 'e.g. DHL, SF Express',
  '如：HS-2024-001': 'e.g. HS-2024-001',
  '如：Holland & Sherry': 'e.g. Holland & Sherry',
  '如：修身、宽松': 'e.g. Slim, Loose',
  '如：对羊毛过敏': 'e.g. Wool allergy',
  '如：细条纹、人字纹': 'e.g. pinstripe, herringbone',
  '姓名': 'Name',
  '婚礼系列': 'Wedding',
  '子账号': 'Sub-accounts',
  '字体': 'Font',
  '字体颜色': 'Font Color',
  '字体颜色（线色号）': 'Font Color (Thread No.)',
  '存储地点': 'Warehouse Location',
  '完成录入待提交': 'Ready to Submit',
  '定制下单': 'Custom Order',
  '定制单提成率': 'MTM Commission Rate',
  '定制设计': 'Custom Design',
  '宝剑头 5cm+暗钩': 'Sword Tip 5cm + Hook & Bar',
  '宝剑头 5cm+锁眼钉扣': 'Sword Tip 5cm + Buttonhole & Button',
  '宝剑头挂面': 'Sword Head Facing',
  '实发工资': 'Net Salary',
  '实发提成': 'Actual Commission Paid',
  '审批人': 'Approved By',
  '审批备注': 'Approval Note',
  '审批状态': 'Approval Status',
  '审核中': 'Under Review',
  '审核通过': 'Reviewed',
  '审核通过，已确认付款': 'Approved, payment confirmed',
  '审核驳回': 'Changes Needed',
  '客供图片': 'Client Image',
  '客供里布': 'Client-supplied Lining',
  '客供': 'Custom',
  '待采': 'Pending',
  '系统': 'System',
  '客供面料': 'My Fabric',
  '当前继承上衣客供面料': 'Inheriting jacket custom fabric',
  '其它面料': 'Other Fabric',
  '其它里布': 'Other Lining',
  '其它纽扣': 'Other Button',
  '客供面料（CMT来料加工）：由客户自行提供面料，发票中面料费用为零，仅计工艺加工费。请填写每块面料的物流信息。': 'Custom fabric (CMT): Client provides fabric. Fabric cost is zero on invoice, only processing fee is charged. Please fill in logistics info for each fabric.',
  '客户': 'Customer',
  '客户/门店': 'Client / Store',
  '客户信息': 'Customer Info',
  '客户信息 & 款式设计': 'Client Info & Style Design',
  '客户信息&款式设计': 'Client & Style',
  '客户创建失败': 'Create failed',
  '客户创建成功': 'Created',
  '客户取消': 'Cancelled',
  '客户名称': 'Client Name',
  '客户基本信息': 'Customer Basic',
  '客户姓名': 'Client Name',
  '客户报价单': 'Client Quotation',
  '客户标签': 'Tags',
  '客户状态': 'Client Status',
  '客户编号': 'Client Code',
  '客户详情': 'Details',
  '宴会系列': 'Banquet',
  '宽松': 'Relaxed',
  '寄件日期': 'Shipping Date',
  '寄出日期': 'Shipped Date',
  '密码': 'Password',
  '密码修改失败': 'Password change failed',
  '密码修改成功': 'Password changed successfully',
  '密钥': 'API Key',
  '对账单': 'Statement',
  '对账截止日': 'Statement End',
  '对账起始日': 'Statement Start',
  '导入': 'Import',
  '导出': 'Export',
  '导出列表': 'Export List',
  '导出功能开发中': 'Export in dev',
  '导出发票': 'Export Invoice',
  '小 U 型': 'Small U-neckline',
  '小圆头 5cm+暗钩': 'Small Round Tip 5cm + Hook & Bar',
  '小圆头 5cm+锁眼钉扣': 'Small Round Tip 5cm + Buttonhole & Button',
  '小圆青果领': 'Small Round Shawl',
  '小腿围': 'Calf',
  '小腿高度': 'Calf Height',
  '小计': 'Subtotal',
  '尖角下摆': 'Pointed Hem',
  '尖青果领（JD 尖青果领）': 'Pointed Shawl Lapel',
  '尺寸录入': 'Measurements',
  '尺寸汇总': 'Size Summary',
  '屈身体': 'Rounded Shoulders',
  '工作台': 'Dashboard',
  '工厂供应商': 'Factory Partners',
  '工厂原始编号': 'Factory Original Code',
  '工厂已确认': 'Factory Confirmed',
  '工厂待审核': 'Factory Pending',
  '工厂成本': 'Factory Cost',
  '工厂成本配置': 'Factory Costs',
  '工字褶': 'Inverted Box Pleat',
  '工艺': 'Workmanship',
  '加工费': 'Processing Fee',
  '工艺类型': 'Construction',
  '工艺配置': 'Workmanship Config',
  '左 1 右 2': 'Left 1, Right 2',
  '左 1 右 3': 'Left 1, Right 3',
  '左 2 右 1': 'Left 2, Right 1',
  '左 2 右 2': 'Left 2, Right 2',
  '左 3': 'Left 3',
  '左 3 右 1': 'Left 3, Right 1',
  '左切角胸袋': 'Left Angled Pocket',
  '左切角胸袋+切角袋盖+锁眼钉扣': 'Left Angled Pocket + Angled Flap + Button',
  '左前片下腰口': 'Left Front Below Waistband',
  '左前腰部（第 4 个纽扣左侧）': 'Left Front Waist (Left of 4th Button)',
  '左单开线袋+锁眼钉扣': 'Left Single Welt + Buttonhole & Button',
  '左单开线袋（无眼无扣）': 'Left Single Welt (No Buttonhole)',
  '左双开线袋+圆扣袢+锁眼钉扣': 'Left Double Welt + Round Tab + Buttonhole & Button',
  '左双开线袋+桃型袋盖': 'Left Double Welt + Rounded Flap',
  '左双开线袋+菱形袋盖': 'Left Double Welt + Diamond Flap',
  '左双开线袋+锁眼钉扣': 'Left Double Welt + Buttonhole & Button',
  '左双开线袋（无眼无扣）': 'Left Double Welt (No Buttonhole)',
  '左右切角胸袋': 'Both Angled Pockets',
  '左右切角胸袋+切角袋盖+锁眼钉扣': 'Both Angled Pockets + Angled Flap + Button',
  '左右圆胸袋': 'Both Round Pockets',
  '左右圆角胸袋+圆角袋盖+锁眼钉扣': 'Both Round Pockets + Round Flap + Button',
  '左右宝剑头调节袢': 'Both-side Normal Adjusters',
  '左右小弧形调节袢': 'Both-side Curved Adjusters',
  '左右尖角胸袋': 'Both Pointed Pockets',
  '左右工字褶贴袋': 'Both Box Pleated Patch Pockets',
  '左右工字褶贴袋（无袋盖）': 'Both Box Pleat Patch Pocket (No Flaps)',
  '左右工字褶贴袋（桃型袋盖+钉扣）': 'Both Box Pleat Patch Pockets(Rounded Flaps + Buttons)',
  '左右工字褶贴袋（直袋盖）': 'Both Box Pleat Patch Pocket (Straight Flaps)',
  '左右方角胸袋': 'Both Square Pockets',
  '左右方角胸袋+切角袋盖+锁眼钉扣': 'Both Square Pockets + Angled Flap + Button',
  '左右方角胸袋+尖角袋盖+锁眼钉扣': 'Both Square Pockets + Pointed Flap + Button',
  '左右方角胸袋+方角袋盖+锁眼钉扣': 'Both Square Pockets + Square Flap + Button',
  '左右暗风琴褶贴袋': 'Both Hidden Accordion Pleated Patch Pockets',
  '左右暗风琴褶贴袋（无袋盖）': 'Both Bellows Patch Pocket (No Flaps)',
  '左右暗风琴褶贴袋（桃型袋盖+钉扣）': 'Both Bellows Patch Pocket (Rounded Flaps + Button)',
  '左右暗风琴褶贴袋（直袋盖）': 'Both Bellows Patch Pocket (Straight Flaps)',
  '左右驳头眼': 'Both Lapels',
  '左商标+右面料标': 'Brand Label Left + Fabric Label Right',
  '左商标+右面料标+领标': 'Brand Left + Fabric Right + Collar Label',
  '左商标右面料标': 'Brand Left, Fabric Right',
  '左圆胸袋': 'Left Round Pocket',
  '左圆角胸袋+圆角袋盖+锁眼钉扣': 'Left Round Pocket + Round Flap + Button',
  '左尖角胸袋': 'Left Pointed Pocket',
  '左工字褶贴袋': 'Left Box Pleated Patch Pocket',
  '左工字褶贴袋（无袋盖）': 'Left Box Pleat Patch Pocket (No Flap)',
  '左工字褶贴袋（桃型袋盖+钉扣）': 'Left Box Pleat Patch Pocket (Rounded Flap + Button)',
  '左工字褶贴袋（直袋盖）': 'Left Box Pleat Patch Pocket (Straight Flap)',
  '左手腕': 'Left Wrist',
  '左挂面袋上居中': 'Left Facing Pocket',
  '左方角胸袋': 'Left Square Pocket',
  '左方角胸袋+切角袋盖+锁眼钉扣': 'Left Square Pocket + Angled Flap + Button',
  '左方角胸袋+尖角袋盖+锁眼钉扣': 'Left Square Pocket + Pointed Flap + Button',
  '左方角胸袋+方角袋盖+锁眼钉扣': 'Left Square Pocket + Square Flap + Button',
  '左暗风琴褶贴袋': 'Left Hidden Accordion Pleated Patch Pocket',
  '左暗风琴褶贴袋（无袋盖）': 'Left Bellows Patch Pocket (No Flap)',
  '左暗风琴褶贴袋（桃型袋盖+钉扣）': 'Left Bellows Patch Pocket (Rounded Flap + Button)',
  '左暗风琴褶贴袋（直袋盖）': 'Left Bellows Patch Pocket (Straight Flap)',
  '左标准明贴袋（无袋盖）': 'Left Patch Pocket (No flap)',
  '左标准明贴袋（桃形袋盖+钉扣）': 'Left Patch Pocket (Rounded Flap + Button)',
  '左标准明贴袋（桃形袋盖）': 'Left Patch Pocket (Curved flap)',
  '左标准明贴袋（直袋盖）': 'Left Patch Pocket with Straight Flap',
  '左胸前': 'Left Chest',
  '左胸弧形贴袋': 'Left Curved Patch Pocket',
  '左胸弧形贴袋（无袋盖）': 'Left Curved Patch Pocket (No Flap)',
  '左腰里刺绣': 'Left Waistband Inside Embroidery',
  '左腰里订商标': 'Brand Label – Left Waistband Inside',
  '左腰里订面料标': 'Fabric Label – Left Waistband Inside',
  '左袖口': 'Left Cuff',
  '左袖比右袖长 0.5cm，应对客户轻微高低肩。': 'Left sleeve 0.5cm longer than right, accommodating slight high-low shoulder.',
  '左袖长': 'Left Sleeve Length',
  '左里袋上居中': 'Left Inner Pocket',
  '左面料标+右商标': 'Fabric Label Left + Brand Label Right',
  '左面料标右商标': 'Fabric Left, Brand Right',
  '左领尖绣字（顺边缘）': 'Left Collar Point (Edge)',
  '左驳头眼顺边绣': 'Left Lapel Buttonhole Edge Embroidery',
  '已付款': 'Paid',
  '已付金额': 'Paid Amt',
  '已发货': 'Shipped',
  '已发货数量': 'Shipped',
  '已发货订单': 'Shipped',
  '已发送': 'Sent',
  '已取消': 'Cancelled',
  '已复制订单': 'Copied',
  '已复用尺寸': 'Reused',
  '已完成': 'Finished',
  '已审核': 'Reviewed',
  '已寄出': 'Shipped',
  '已开票': 'Invoiced',
  '已提交': 'Submitted',
  '已提交订单': 'Submitted Orders',
  '已收货': 'Received',
  '已暂存为草稿': 'Draft Saved',
  '已查看': 'Viewed',
  '已用额度': 'Used Credit',
  '已申请': 'Submitted',
  '已确认': 'Confirmed',
  '已确认付款': 'Payment confirmed',
  '已签收': 'Delivered',
  '已质检': 'Inspected',
  '已送达': 'Delivered',
  '已选': 'Selected',
  '已选择': 'Selected',
  '已选择现款设计': 'Selected stock design',
  '已选：': 'Selected: ',
  '已采购': 'Purchased',
  '已锁定（与': 'Locked (same as ',
  '已驳回': 'Rejected',
  '带盖口袋': 'Flap Pocket',
  '常规': 'Standard',
  '常规加厚肩（垫肩 1.2cm + 有棉条）': 'Heavy Regular Shoulder (1.2cm pad + wadding)',
  '常规款': 'Standard',
  '常规纽扣': 'Standard Buttons',
  '常规肩（垫肩 0.8cm + 有棉条）': 'Regular Shoulder (0.8cm pad + wadding)',
  '常规薄肩（垫肩 0.5cm + 有棉条）': 'Light Padded Shoulder (0.5cm pad + wadding)',
  '常规超薄肩（垫肩 0.1cm + 有棉条）': 'Ultra Light Shoulder (0.1cm pad + wadding)',
  '常规里袋 + 一字笔袋': 'Standard Inside Pocket + Straight Pen Pocket',
  '常规里袋 + 一字笔袋 + 卡袋': 'Standard Inside Pocket + Straight Pen + Card Pocket',
  '常规里袋 + 水滴笔袋': 'Standard Inside Pocket + Teardrop Pen Pocket',
  '常规里袋 + 水滴笔袋 + 卡袋': 'Standard Inside Pocket + Teardrop Pen + Card Pocket',
  '平台服务费': 'Service Fee',
  '平肩': 'Square Shoulder',
  '平脚': 'Plain Hem',
  '平腰头+暗钩': 'Flat Waistband + Hook & Bar',
  '平腰头+锁眼钉扣': 'Flat Waistband + Buttonhole & Button',
  '平袋盖（直角）': 'Straight Flap (Square)',
  '平角青果领': 'Square Shawl',
  '平驳头': 'Notch Lapel',
  '平驳领': 'Notch Lapel',
  '年度税后利润': 'Annual Net Profit (CNY)',
  '库存': 'Stock',
  '库存不足，请选择其他物料或联系客服。': 'Out of stock. Please choose another option or contact us.',
  '库存流水': 'Inventory Log',
  '库存物料': 'Inventory',
  '库存管理': 'Inventory',
  '库存调整': 'Adjust Stock',
  '应付总金额': 'Total Due',
  '应发工资': 'Gross Salary',
  '度假系列': 'Resort',
  '开始日期': 'Start Date',
  '开始生产前需支付50%定金。': 'A 50% deposit is required before production begins.',
  '开票日期': 'Invoice Date',
  '异常冻结': 'On Hold',
  '异常订单': 'On Hold',
  '弧形工字褶贴袋': 'Curved Box Pleat Patch Pocket',
  '弧形工字褶贴袋（桃型袋盖）': 'Curved Box Pleat Patch Pocket (Rounded Flap)',
  '弧形工字褶贴袋（直袋盖）': 'Curved Box Pleat Patch Pocket(Straight Flap)',
  '弧形戗驳领': 'Curved Peak Lapel',
  '弧形暗风琴褶贴袋': 'Curved Hidden Accordion Pleated Patch Pocket',
  '弧形暗风琴褶贴袋（桃型袋盖）': 'Curved Bellows Patch Pocket (Rounded Flap)',
  '弧形暗风琴褶贴袋（直袋盖）': 'Curved Bellows Patch Pocket (Straight Flap)',
  '弧形胸袋': 'Curved Chest Pocket',
  '弧形贴袋': 'Curved Patch Pocket',
  '弧形贴袋+ 右袋中袋': 'Curved Patch Pocket with Right Ticket Pocket',
  '弧形贴袋（时尚贴袋）': 'Curved Patch Pocket (Barchetta)',
  '弯挂面': 'Curved Facing',
  '当前在线门店': 'Stores Online',
  '当前密码': 'Current Password',
  '当前库存': 'In Stock',
  '当前折扣率为': 'Current discount rate is',
  '当前状态': 'Current Status',
  '待付款': 'Awaiting Payment',
  '待付金额': 'Amount Due',
  '待初审': 'Pending Initial Review',
  '待发货': 'Ready to Ship',
  '待复审': 'Pending Tailor Review',
  '待完成': 'Pending',
  '待审核': 'Pending',
  '待审核订单': 'Pending Review',
  '待审核订单总数': 'Total Pending Review',
  '待审核金额(USD)': 'Pending Review Amount (USD)',
  '待开票': 'Pending Invoice',
  '待推送': 'Ready for Factory',
  '待提交订单': 'Temp Orders',
  '待确认': 'Pending',
  '待确认付款': 'Pending Payments',
  '待终审': 'Pending Final Review',
  '待财务审核': 'Pending Finance Review',
  '待质检': 'Pending QC',
  '待选': 'To Select',
  '待采购': 'Pending Purchase',
  '待采购面料': 'Fabric Pending Purchase',
  '心型': 'Heart Shape Milanese',
  '忘记密码': 'Forgot Password',
  '快捷下单': 'Quick Order',
  '快递运单号': 'Tracking Number',
  '快速搜索': 'Quick Search',
  '性别': 'Gender',
  '总SKU': 'Total SKU',
  '总肩宽': 'Shoulder Width',
  '总采购额': 'Total Purchases',
  '您有未保存的更改，是否继续编辑？': 'You have unsaved changes. Leave without saving?',
  '意式圆形 1 扣': 'Italian Round 1-Button',
  '意式圆形 2 扣': 'Italian Round 2-Button',
  '意式直型 1 扣': 'Italian Straight 1-Button',
  '意式直型 2 扣': 'Italian Straight 2-Button',
  '意式长双宝剑头+锁眼钉扣': 'Italian Double Sword Extension + Button Fastening',
  '意式长圆头+锁眼钉扣': 'Italian Round Extension + Button Fastening',
  '意式长方头+锁眼钉扣': 'Italian Square Extension + Button Fastening',
  '成分': 'Composition',
  '成本明细': 'Cost details',
  '成衣商城': 'Ready-to-Wear',
  '成衣商城功能开发中，敬请期待': 'Store coming soon',
  '成衣尺寸': 'Finished',
  '审核成衣尺寸': 'Audit Finished Size',
  '成衣尺寸（AI建议）': 'Garment Size (AI Suggestion)',
  '我的客户': 'Clients',
  '我的物料': 'Materials',
  '我的订单': 'Orders',
  '我的设计专员': 'My Designer',
  '我的账单': 'My Bills',
  '我的账号': 'Account',
  '戗驳头': 'Peak Lapel',
  '所属门店': 'Store',
  '所有价格以美元（USD）计算，自报价日起30天内有效。': 'All prices are in USD and valid for 30 days from the date of quotation.',
  '所有服装均为量身定制，不接受退换。': 'All garments are made-to-measure and non-returnable.',
  '所有订单': 'All Orders',
  '所有订单管理': 'All Orders',
  '所有金额以美元(USD)计价。实际价格可能根据面料等级、批量折扣等规则进行调整，最终以后台审核后的价格为准。': 'All amounts in USD. Final price subject to review.',
  '所选品类': 'Selected Categories',
  '所选物料在当前工厂不可用。': 'This material isn\'t available at the selected factory.',
  '手动发送公告': 'Send Announcement',
  '手工同步状态': 'Manual Sync',
  '手工圆头锁眼': 'Handmade Function Buttonhole',
  '手工米兰眼不开刀': 'Handmade Non-function Milanese',
  '手工米兰眼开刀': 'Handmade Function Milanese',
  '手工调价': 'Manual Price Adjustment',
  '扣减': 'Deduction',
  '扣款合计': 'Total Deduction',
  '批量价格表': 'Bulk Price List',
  '批量发送邮件': 'Email All',
  '批量打印面单': 'Batch Print Labels',
  '批量折扣': 'Bulk Discount',
  '批量操作': 'Bulk Actions',
  '技术审核时间': 'Technical Review Time',
  '技术已审核': 'Technical review completed',
  '投产工厂': 'Production Factory',
  '投诉与反馈': 'Complaints & Feedback',
  '投诉与反馈邮箱': 'Feedback Email',
  '货币单位：USD': 'Currency: USD',
  '折扣': 'Discount',
  '折，低于系统设置的最低折扣系数，需要提交折扣审批申请。': 'fold, below the minimum discount threshold set by the system. A discount approval application is required.',
  '报价工具': 'Quotation Tool',
  '报价总额（USD）': 'Grand Total (USD)',
  '报价日期': 'Quote Date',
  '报废': 'Scrap',
  '拖拽排序': 'Drag to reorder',
  '挂面款式': 'Facing Style',
  '按件': 'Per Item',
  '按功能分类': 'By Function',
  '按图设计': 'Custom Design',
  '按图设计款': 'Custom Design',
  '按场合分类': 'By Occasion',
  '按字母': 'Per Letter',
  '按季节分类': 'By Season',
  '按订单': 'Per Order',
  '挺缝线压线 0.2cm': 'Front Line Topstitch 0.2cm',
  '挺胸体': 'Prominent Chest',
  '接口地址': 'API Endpoint',
  '接收角色': 'Recipient Roles',
  '推送失败': 'Send Failed',
  '推送工厂': 'Send to Factory',
  '描述': 'Description',
  '提交': 'Submit',
  '提交失败': 'Submit Failed',
  '提交失败，请检查网络或后端服务': 'Submit failed, check backend',
  '提交审批失败': 'Failed to submit for approval',
  '提交审核': 'Submit for Review',
  '提交审核成功': 'Submitted successfully',
  '提交折扣审批': 'Submit Discount Approval',
  '提交申请': 'Submit Request',
  '提交订单': 'Place Order',
  '提成合计': 'Total Commission',
  '提成明细': 'Commission Details',
  '提成规则配置': 'Commission Rules',
  '提成金额': 'Commission Amount',
  '清除': 'Clear',
  '搜索': 'Search',
  '搜索位置...': 'Search position...',
  '搜索历史订单': 'Search history',
  '搜索姓名/电话/邮箱/地址': 'Search contacts',
  '搜索字体...': 'Search font...',
  '搜索工艺类型、订单号、客户名、面料编码...': 'Search craft type, order no, customer, fabric code...',
  '搜索物料': 'Search materials',
  '搜索编号 / 颜色': 'Search Fabric/Color',
  '搜索编号/名称...': 'Search code/name...',
  '搜索编号/颜色': 'Search Fabric/Color',
  '搜索订单号/客户/门店': 'Search order no/customer/store',
  '搜索订单号/客户/面料': 'Search',
  '搜索选择客户': 'Select customer',
  '搜索颜色...': 'Search color...',
  '搜索高度...': 'Search height...',
  '摆围': 'Hem',
  '撞色设计': 'Contrast Design',
  '撞色面料': 'Contrast Fabric',
  '操作': 'Actions',
  '操作人': 'Operator',
  '操作内容': 'Action',
  '操作失败': 'Something went wrong',
  '操作成功': 'Done',
  '操作日志': 'Operation Log',
  '操作时间': 'Time',
  '支付方式': 'Payment Method',
  '收支明细': 'Transaction Details',
  '收货单': 'Receiving Note',
  '收货地址': 'Shipping Addr',
  '收货地点': 'Ship To',
  '收货管理': 'Incoming',
  '收费系列': 'Charged Lining',
  '放松量': 'Fit Allowance',
  '数据录入校验 (Checklist)': 'Data Entry Check (Checklist)',
  '数据看板': 'Reports',
  '数量': 'Quantity',
  '整个袖口撞色': 'Full Cuffs Contrast',
  '整个领子和袖口撞色': 'Full Collar + Cuffs Contrast',
  '整个领子撞色': 'Full Collar Contrast',
  '文字': 'Text',
  '料卡': 'Fabric Books',
  '斜双开线口袋': 'Slanted Double Welt Pocket',
  '斜插袋': 'Slanted Pocket',
  '斜袋': 'Slant Pocket',
  '斜袋：单线袋': 'Slanted+  Single Besom',
  '斜袋：双线大袋（有袋盖）+一字票袋（无袋盖）': 'Slanted: Flapped Double Besom + Welt Ticket Pocket',
  '斜袋：双线大袋（有袋盖）+双线票袋（无袋盖）': 'Slanted: Flapped Double Besom + Double Besom Ticket (No Flap)',
  '斜袋：双线大袋（有袋盖）+双线票袋（有袋盖）': 'Slanted+ Flapped Double Besom + Ticket Pocket (Flap)',
  '斜袋：双线大袋（直角袋盖）+双线票袋（直角袋盖）': 'Slanted: Double Besom (Square Flap) + Double Besom Ticket (Square Flap)',
  '斜袋：双线袋+小圆直袋盖': 'Slanted + Double Besom + Small Round Flap',
  '斜袋：双线袋无袋盖': 'Slanted+ Double Besom without Flap',
  '斜袋：双线袋（无盖）+双线票袋（无盖）': 'Slanted: Double Besom (No Flap) + Double Besom Ticket (No Flap)',
  '斜袋：平袋盖（直角）': 'Slanted: Flat Flap (Square)',
  '斜角青果领': 'Angled Shawl',
  '斜里襟+内小圆头裤袢': 'French Bearer + Small Round Inner Tab',
  '斜里襟+内小宝剑头裤袢': 'French Bearer + Small Sword Inner Tab',
  '斜里襟+内小方头裤袢': 'French Bearer + Small Square Inner Tab',
  '断货': 'Out of Stock',
  '新品上架': 'New Arrivals',
  '新增付款记录': 'Add Payment',
  '新增客户': 'Add Client',
  '新增尺寸': 'Add Measurement',
  '新增尺寸记录': 'New Measurement',
  '新增返修单': 'New Alteration',
  '新增量体档案': 'New Profile',
  '新备注': 'New Remark',
  '新密码': 'New Password',
  '新建订单': 'New Order',
  '新款发布': 'New Arrivals',
  '新面料上线': 'New Fabrics',
  '新面料系列现已上架，欢迎选购': 'New fabrics!',
  '方式': 'Method',
  '无': 'None',
  '添加图片': 'Add Image',
  '无体型和款式图': 'No body/style photos',
  '无体型特征记录': 'No body features recorded',
  '无刺绣': 'No Embroidery',
  '无叉': 'No Vent',
  '无口袋': 'No Pockets',
  '无开口': 'No Opening',
  '无开衩': 'No Vent',
  '无弧度戗驳领（JD 直戗驳领）': 'Straight Peak Lapel',
  '无折扣': 'No Discount',
  '无挺缝线': 'No Crease',
  '无插片': 'No Collar Stays',
  '无数据': 'No data',
  '无标': 'No Label',
  '无省': 'No Darts',
  '无结构无胸衬': 'Unstructured',
  '无背带扣': 'No Suspender Buttons',
  '无胸袋': 'No Chest Pocket',
  '无胸袋+下单开线袋': 'No Chest Pocket + Single Welt Lower',
  '无胸袋+下双开线袋': 'No Chest Pocket + Double Welt Lower',
  '无胸袋+下贴袋': 'No Chest Pocket + Patch Lower',
  '无腰带': 'No Back Belt',
  '无腰设计': 'No Waistband',
  '无色丁': 'No Satin',
  '无表袋': 'No Watch Pocket',
  '无衬': 'No Interlining',
  '无袋': 'No Pocket',
  '无袋盖': 'No Flap',
  '无袖叉': 'No Vent',
  '无裤袢': 'No Belt Loops',
  '无褶': 'Flat Front',
  '无褶双省': 'No Pleats + Double Darts',
  '无褶无褶': 'No Pleats',
  '无贡针': 'No Stitch',
  '无里布': 'Unlined',
  '无锁眼无纽扣': 'No Buttonhole, No Button',
  '无驳头眼': 'No Lapel Buttonhole',
  '日': '',
  '日常通知': 'General Notifications',
  '日志管理': 'Logging',
  '日期': 'Date',
  '时尚档': 'STYLISH',
  '时尚档（高）': 'STYLISH (High)',
  '时间': 'Time',
  '明细': 'Details',
  '明门襟 3.5cm': 'Standard Placket 3.5cm',
  '明门襟 3cm': 'Standard Placket 3cm',
  '春秋': 'Spring/Autumn',
  '是': 'Yes',
  '否': 'No',
  '提示': 'Tip',
  '当前订单保存为草稿时才可以生成 AI预览图，是否保存？': 'The current order needs to be saved as a draft before generating an AI preview. Save now?',
  '是否余料': 'Leftover Fabric',
  '是否加急': 'Rush',
  '显示 / 隐藏': 'Show / Hide',
  '显示高级信息': 'Show Advanced',
  '普通': 'Normal',
  '普通工字褶贴袋': 'Standard Box Pleat Patch Pocket',
  '普通工字褶贴袋（桃型袋盖）': 'Standard Box Pleat Patch Pocket (Rounded Flap)',
  '普通工字褶贴袋（直袋盖）': 'Standard Box Pleat Patch Pocket(Straight Flap)',
  '普通暗风琴褶贴袋': 'Standard Hidden Accordion Pleated Patch Pocket',
  '普通暗风琴褶贴袋（桃型袋盖）': 'Standard Bellows Patch Pocket (Rounded Flap)',
  '普通暗风琴褶贴袋（直袋盖）': 'Standard Bellows Patch Pocket (Straight Flap)',
  '普通贴袋': 'Standard Patch Pocket',
  '普通贴袋+右袋中袋': 'Patch Pocket with Right Ticket Pocket',
  '暂不取消': 'Cancel Later',
  '暂存': 'Temp Save',
  '暂存功能开发中': 'Draft in dev',
  '暂存单': 'Drafts',
  '暂存单数量': 'Temp Orders',
  '暂存失败': 'Draft Failed',
  '暂存订单': 'Temp Orders',
  '草稿已保存': 'Draft saved',
  '保存修改并提交': 'Save & Submit',
  '请完善客户信息': 'Please complete customer info',
  '客户档案保存失败，请重试': 'Customer profile save failed, please retry',
  '您的账号尚未通过门店审核，暂时无法下单': 'Your account has not been approved by the store yet',
  '门店已被禁用，请联系管理员': 'This store has been disabled. Please contact the administrator.',
  '权限不足，无法操作': 'Permission denied. Unable to perform this operation.',
  '您的账号尚未分配门店，请联系业务员': 'Your account has not been assigned to a store. Please contact your designer.',
  '账号未关联有效门店，暂时无法创建或保存订单': 'Your account is not linked to an active store. You cannot create or save orders at this time.',
  '暂无付款记录': 'No payments',
  '暂无刺绣配置': 'No embroidery config',
  '暂无发票': 'No invoices',
  '暂无售后记录': 'No after-sales',
  '暂无商品': 'No products',
  '暂无图片': 'No images',
  '暂无备注': 'No remarks',
  '暂无客户数据': 'No customers',
  '暂无客户，点击 “新增客户” 创建。': 'No clients yet. Add your first client.',
  '暂无寄出记录': 'No shipments',
  '暂无待审核订单': 'No pending review orders',
  '暂无数据': 'No data',
  '暂无款式配置': 'No style config yet',
  '暂无款式配置，请在Step1中选择': 'No style config, please select in Step 1',
  '暂无流水记录': 'No transactions',
  '暂无消息': 'No messages',
  '暂无系统面料数据': 'No fabric data',
  '暂无订单': 'No orders',
  '暂无订单数据': 'No data',
  '暂无订单，点击 “创建新订单” 开始。': 'No orders yet. Start by creating a new order.',
  '暂无记录': 'No records',
  '暂无设计选项': 'No design options',
  '暂无设计项': 'No design items',
  '暂无购买记录': 'No purchases',
  '暂无采购记录': 'No procurement',
  '暂无量体档案': 'No records',
  '暗门襟 3.5cm': 'Hidden Placket 3.5cm',
  '暗门襟 3cm': 'Hidden Placket 3cm',
  '更多': 'More',
  '更多设计': 'More Options',
  '最新面料': 'New Fabrics',
  '最新面料/新款发布': 'Latest Fabrics',
  '最近下单': 'Recent',
  '最近下单日期': 'Last Order',
  '最近订单': 'Recent Orders',
  '月': '/',
  '月份': 'Period',
  '月处理订单量': 'Monthly Admin Order Count',
  '月牙袋+右双线零钱袋': 'Curved Denim Pocket  + Right Double Welt Coin Pocket',
  '月牙袋+右零钱贴袋': 'Curved Denim Pocket  + Right Coin Patch Pocket',
  '月负责订单金额': 'Monthly Tracked Order Amount',
  '月销售额': 'Monthly Sales',
  '有效期至': 'Valid Until',
  '有背带扣': 'With Suspender Buttons',
  '有货': 'In Stock',
  '服务与反馈中心': 'Service Center',
  '服务暂时不可用，请稍后重试。': 'We\'re having some trouble. Please try again later.',
  '服务项目': 'Service',
  '服装小计': 'Clothing Subtotal',
  '未付款': 'Unpaid',
  '未付余额': 'Balance Due',
  '凭证图片': 'Payment Proof',
  '确认时间': 'Confirmed At',
  '已作废': 'Voided',
  '下载 PDF': 'Download PDF',
  '承运商': 'Carrier',
  '发货图片': 'Shipping Images',
  '未付款提醒': 'Unpaid Reminder',
  '未发送': 'Not Sent',
  '未找到结果，请尝试其他关键词。': 'No matches found. Try a different search term.',
  '未来之星': 'Future Star',
  '未知': 'Unknown',
  '未知错误': 'Unknown error',
  '未选择': 'Not selected',
  '未选择面料': 'No Fabric',
  '本人团单销售额': 'Personal RTW Sales',
  '本人定制单销售额': 'Personal MTM Sales',
  '本人权重点数': 'Personal Weight',
  '本布光样': '2nd Finished Basted Fitting',
  '本布光样手工': 'Handmade Finished Basted Fitting',
  '本布手工毛样': 'Handmade Basted Fitting',
  '本布毛样': 'Basted Fitting',
  '本月新单': 'New This Month',
  '本期余额': 'Current Balance',
  '本期支出': 'Expense',
  '本期收入': 'Income',
  '机器假眼不开刀': 'Machine Non-function Buttonhole',
  '机器假眼开刀': 'Machine Function Buttonhole',
  '机器圆头锁眼不开刀': 'Machine Non-function Rounded Buttonhole',
  '机器圆头锁眼开刀': 'Machine Function Rounded Buttonhole',
  '权限': 'Permissions',
  '权限分配': 'Permissions',
  '条款与条件': 'Terms & Conditions',
  '来图设计': 'Custom Design',
  '来料加工': 'Customer\'s Own Material (CMT)',
  '来料加工价格': 'CMT Price',
  '来料加工价格表': 'CMT Price List',
  '查看': 'View',
  '查看全部': 'View All',
  '查看发票': 'View Invoice',
  '查看合并发票': 'View Combined Invoice',
  '查看售后沟通': 'View After-sales',
  '查看背面': 'View Back',
  '查看订单': 'View Orders',
  '查看订单详情': 'View Details',
  '查看详情': 'View',
  '查看账单': 'View Bills',
  '标准': 'Standard',
  '标准价格表': 'Standard Price List',
  '标准体': 'Standard',
  '标准八字领': 'Classic Spread Collar',
  '标准圆角': 'Standard Round',
  '标准工艺': 'Standard',
  '标准腰带': 'Standard Back Belt',
  '标准贡针': 'Standard',
  '标准领': 'Point Collar',
  '标准（14 天）': 'Standard (14 days)',
  '标签': 'Tags',
  '标签搜索': 'Tags',
  '标记异常': 'Flag Issue',
  '标题': 'Title',
  '样本册': 'Book',
  '档位面料价（USD/m）': 'Grade Price (USD/m)',
  '档案名称': 'Record Name',
  '检测到新版本，请点击下方按钮刷新页面获取最新资源。': 'A new version is detected. Please click the button below to refresh and get the latest resources.',
  '检索标签': 'Search Tags',
  '棕色': 'Brown',
  '棕色法兰绒': 'Brown Flannel',
  '欢迎回来': 'Welcome Back',
  '欢迎回来，查看您的订单和账户状态': 'Welcome back, check your orders and account status',
  '款号': 'Style No.',
  '款式信息': 'Style Info',
  '款式名称': 'Style Name',
  '款式明细': 'Style Details',
  '款式设计': 'Style Design',
  '款式配置汇总': 'Style Summary',
  '款式长度': 'Style Length',
  '款式预览': 'Style Preview',
  '款式风格': 'Style',
  '款式风格搭配': 'Style Match',
  '正常': 'Regular',
  '正常 14天': 'Normal 14d',
  '正常14天': 'Standard 14d',
  '正常腰头': 'Standard Waistband',
  '正式': 'Formal',
  '正面': 'Front',
  '正面图': 'Front',
  '此字段为必填项。': 'This field is required.',
  '每件': 'Per Item',
  '每单': 'Per Order',
  '每字': 'Per Letter',
  '毛利': 'Gross Profit',
  '毛利率': 'Gross Margin',
  '毛边 10cm': 'Unfinished Hem (10cm extra)',
  '毛边 7cm': 'Unfinished Hem (7cm extra)',
  '汇款': 'Transfer',
  '汗贴造型': 'Sweat Guard',
  '沟通': 'Communication',
  '沟通态度': 'Communication',
  '法式切角': 'French Angled',
  '法式圆角': 'French Rounded',
  '法式斜里襟': 'French Bearer',
  '法式直角': 'French Square',
  '法式袖口': 'French Cuff',
  '注册时间': 'Registered Date',
  '活动系列': 'Events',
  '活跃': 'Active',
  '测试连接': 'Test Connection',
  '浏览商品': 'Browse',
  '海军蓝人字纹': 'Navy Blue Herringbone',
  '海量面料，一键选购': 'Fabrics galore',
  '海鸥型': 'Seagull Shape Milanese',
  '消息中心': 'Messages',
  '消息类型': 'Message Type',
  '消息评论': 'Comments',
  '消费': 'Purchase',
  '消费金额': 'Amount Spent',
  '深灰': 'Dark Grey',
  '深灰大方格': 'Dark Grey Windowpane',
  '深藏青': 'Dark Navy',
  '深藏青羊毛': 'Dark Navy Wool',
  '深藏青羊毛裙料': 'Dark Navy Wool Skirt',
  '深藏青羊毛裤料': 'Navy Wool Trouser',
  '添加': 'Add',
  '添加体型特征': 'Add Profile',
  '添加刺绣': 'Add Embroidery',
  '添加备注': 'Add Remark',
  '添加新的量体说明或客户特殊偏好...': 'Add new measurement notes or customer special preferences...',
  '添加特体': 'Add Body Feature',
  '添加面料': 'Add Fabric',
  '清除缓存': 'Clear Cache',
  '时区': 'Timezone',
  '温莎领': 'Spread Collar',
  '温莎领（内弧）': 'Windsor Collar',
  '溜肩': 'Sloping Shoulder',
  '灰色': 'Grey',
  '灰色精纺': 'Grey Worsted',
  '灰色里布': 'Grey Lining',
  '灰色防滑腰里': 'Grey Anti-slip',
  '烟斗型': 'Pipe Shape Milanese',
  '熨烫挺缝线': 'Pressed Crease',
  '版型': 'Pattern Making',
  '版型 / 款式库': 'Style Library',
  '版型参数': 'Pattern Parameters',
  '牛角扣': 'Horn Button',
  '物料中心': 'Material Hub',
  '物料供应商': 'Material Suppliers',
  '物料分类': 'Material Type',
  '物料品牌': 'Material Brand',
  '物料寄出': 'Shipment',
  '物料寄出管理': 'Materials Shipped',
  '物料小部件': 'Material Widget',
  '物料明细': 'Items',
  '物料管理': 'Material Management',
  '物料编号': 'Material Code',
  '物料采购': 'Procurement',
  '物流': 'Logistics',
  '物流信息': 'Logistics Info',
  '物流公司': 'Shipping Company',
  '物流单号': 'Tracking #',
  '物流单号格式错误。': 'Tracking number format is incorrect.',
  '物流方式': 'Shipping Method',
  '物流费': 'Shipping',
  '物流费用': 'Shipping Cost',
  '物流轨迹': 'Tracking History',
  '物流追踪单号': 'Tracking',
  '特急（5 天）': 'Express (5 days)',
  '特殊纽扣': 'Special Buttons',
  '特殊要求': 'Special Req',
  '特殊设计': 'Special Design',
  '特殊设计费': 'Special Design',
  '额外面料费': 'Extra Fabric',
  '特殊里衬': 'Special Lining',
  '状态': 'Status',
  '状态变更时间线': 'Status Timeline',
  '状态映射': 'Status Mapping',
  '现款设计': 'Ready-made Design',
  '珍珠母贝': 'Mother of Pearl',
  '开始推送': 'Pushing to Factory',
  '生产中': 'In Production',
  '生产完成': 'Production Complete',
  '生产中数量': 'In Production',
  '生产中订单': 'In Production',
  '生成报价单': 'Generate Quotation',
  '生成日期': 'Generated',
  '用户名': 'Username',
  '用户名或密码错误。': 'Login failed. Please check your email and password.',
  '用户管理': 'Users',
  '用此尺寸下单': 'Order with size',
  '由于选择了重磅法兰绒面料，放松量已手动增加 0.5cm 以确保动态舒适度。': 'Due to the selection of heavy-weight flannel fabric, ease has been manually increased by 0.5cm to ensure dynamic comfort.',
  '申请售后': 'Request After-sales',
  '申请折扣率': 'Requested Discount Rate',
  '申请时间': 'Requested At',
  '电子邮件': 'Email',
  '电子邮箱': 'Email',
  '电话': 'Phone',
  '男': 'Male',
  '界面风格配置': 'Theme',
  '登出': 'Sign Out',
  '登录': 'Sign In',
  '登录失败': 'Sign in failed',
  '登录失败，请检查用户名和密码': 'Sign in failed. Please check your username and password.',
  '请输入用户名和密码': 'Please enter username and password',
  '密码错误次数过多，账号已锁定30分钟，请稍后再试': 'Too many failed attempts. Account locked for 30 minutes.',
  '用户名或密码错误': 'Incorrect username or password',
  '登录成功': 'Sign in successful',
  '该账号无权限登录门店端': 'This account is not authorized to access the store portal',
  '登记寄出物料': 'Register Ship',
  '登记成功': 'Registered',
  '白色': 'White',
  '白色无防滑腰里': 'White Standard',
  '白色涤纶里布': 'White Polyester Lining',
  '白色纯棉': 'White Cotton',
  '白色里布': 'White Lining',
  '白色防滑腰里': 'White Anti-slip',
  '百褶裙': 'Pleated Skirt',
  '皮鞋': 'Shoes',
  '盘亏': 'Stock Out',
  '盘盈': 'Stock In',
  '直下摆': 'Straight Hem',
  '直属上级': 'Direct Supervisor',
  '直开口': 'Straight Opening',
  '直开口+手工套结': 'Straight Opening + Hand Bartack',
  '直挂面': 'Straight Facing',
  '直挂面 + 小宝剑头': 'Straight Facing + Small Sword',
  '直挂面+小宝剑头': 'Simple Straight Facing + Small Sword Tip',
  '直摆': 'Straight Hem',
  '直摆+五角布贴': 'Straight Hem + Pentagon Gusset',
  '直袋': 'Straight Pocket',
  '直角 1 眼 2 扣': 'Square 1-Buttonhole 2-Buttons',
  '直角 2 眼 2 扣': 'Square 2-Buttonholes 2-Buttons',
  '直角两用': 'Square Convertible Cuff',
  '直角立体贴袋 + 桃型袋盖': '3D Patch Pocket (Curvedflap)',
  '直角立体贴袋 + 直袋盖': '3D Patch Pocket (Straight flap)',
  '直角立体贴袋+桃型袋盖': 'Square 3D Patch Pocket + Rounded Flap',
  '直角立体贴袋+直袋盖': 'Square 3D Patch Pocket + Straight Flap',
  '直贴布中褶': 'Straight Placket – Medium Tuck',
  '直贴布大褶': 'Straight Placket – Large Tuck',
  '直贴布小褶（塔克）': 'Straight Placket – Small Tuck',
  '直门襟': 'Straight Fly',
  '相同）': ')',
  '真丝红色': 'Silk Red',
  '真丝里布': 'Silk Lining',
  '真实姓名': 'Real Name',
  '真袖叉': 'Functional Vent',
  '真袖叉圆弧翻边（4.5cm）': 'Functional Vent + Functional Buttonhole + Curved Turn-up 4.5cm',
  '真袖叉圆弧翻边（7.5cm）': 'Functional Vent + Functional Buttonhole + Curved Turn-up 7.5cm',
  '真袖叉直翻边（4.5cm）': 'Functional Vent + Functional Buttonhole + Straight Turn-up 4.5cm',
  '真袖叉直翻边（7.5cm）': 'Functional Vent + Functional Buttonhole + Straight Turn-up 7.5cm',
  '短款': 'Short',
  '短袖': 'Short Sleeve',
  '短袖假翻边': 'Short Sleeve & Turn-up Hem',
  '短袖内折边': 'Short Sleeve & Standard Hem',
  '短裙': 'Short Skirt',
  '码': 'Yard',
  '码标订后复势': 'Size Label on Back Yoke',
  '硬衬': 'Hard Interlining',
  '确定删除该记录吗？此操作不可撤销。': 'Deleting... This action cannot be undone.',
  '确定要取消此订单吗？取消后不可恢复。': 'Are you sure you want to cancel this order? This cannot be undone.',
  '确定要取消该订单吗？取消后不可恢复。': 'Cancel order? Cannot undo.',
  '确定要复制此订单吗？将创建一个新订单并保留所有配置。': 'Are you sure you want to copy this order? A new order will be created with all configurations preserved.',
  '确认': 'Confirm',
  '确认 & 提交': 'Confirm & Submit',
  '确认付款': 'Confirm Payment',
  '确认付款并审核通过': 'Confirm Payment & Approve',
  '确认到账': 'Confirm Receipt',
  '确认取消': 'Confirm Cancel',
  '确认取消该订单？取消后无法恢复。': 'Confirm cancellation? This cannot be reversed.',
  '确认提交': 'Place Order',
  '确认提成': 'Confirm Commission',
  '确认收货': 'Confirm Received',
  '确认收货？此操作不可撤销。': 'Confirm receipt? This action cannot be undone.',
  '确认新密码': 'Confirm New Password',
  '确认登记': 'Confirm Register',
  '确认移除品类?': 'Remove?',
  '确认签收失败': 'Confirm receipt failed',
  '确认签收成功': 'Confirm receipt successful',
  '确认订单': 'Confirm Order',
  '确认订单后，生产周期为4–6周。': 'Production lead time is 4–6 weeks after order confirmation.',
  '确认驳回': 'Confirm Rejection',
  '磅': 'lb',
  '礼服系列': 'Formal Wear',
  '礼服门襟 3.5cm（4 个 STUDS）': 'Dress Placket 3.5cm (4 Studs)',
  '礼服门襟 3.5cm（所有都是 STUDS）': 'Dress Placket 3.5cm (All Studs)',
  '礼服门襟 3cm（4 个 STUDS）': 'Dress Placket 3cm (4 Studs)',
  '礼服门襟 3cm（所有都是 STUDS）': 'Dress Placket 3cm (All Studs)',
  '礼服领': 'Dress Collar',
  '社会保险': 'Social Insurance',
  '禁忌 / 特殊要求': 'Special Requests',
  '禁忌/特殊要求': 'Special Requests',
  '禁用': 'Disable',
  '种': ' types',
  '穿着风格偏好': 'Style Preference',
  '立即下单': 'Order Now',
  '等': ' etc.',
  '筛选': 'Filter',
  '管理所有定制订单': 'Manage all custom orders',
  '米': 'Meter',
  '米/码': 'Meter/Yard',
  '米数': 'Meters',
  '米色': 'Beige',
  '类型': 'Type',
  '粘合衬厚胸衬': 'Fused (Heavy)',
  '粘合衬薄胸衬': 'Fused (Light&Soft)',
  '粘衬': 'Fused / Glued',
  '精准算料': 'Calculate',
  '系统图片': 'System Image',
  '系统更新': 'System Updates',
  '系统消息': 'Notifications',
  '系统设置': 'Settings',
  '系统面料': 'In Stock',
  '紧急': 'Urgent',
  '紧身': 'Tight',
  '累计消费金额': 'Total Spent',
  '累计订单': 'Total Orders',
  '红色': 'Red',
  '纽扣': 'Buttons',
  '纽扣数': 'Button Count',
  '纽扣领': 'Button-down Collar',
  '纽约旗舰店': 'NY Flagship',
  '终端消费者': 'End Consumers',
  '经典尖领': 'Classic Point Collar',
  '经典戗驳领': 'Classic Peak Lapel',
  '结束日期': 'End Date',
  '结果': 'Result',
  '结算': 'Checkout',
  '绣字内容': 'Embroidery Text',
  '绩效': 'Performance Bonus',
  '缓存已清除': 'Cache Cleared',
  '编号': 'No.',
  '编辑': 'Edit',
  '编辑价格体系': 'Edit Pricing',
  '缺少客户信息': 'Missing customer',
  '缺货': 'Out of Stock',
  '网络错误': 'Network error',
  '网络错误，请检查后端服务是否启动': 'Network error, check backend',
  '网络错误，请检查连接后重试。': 'Connection lost. Please check your network.',
  '设计选项加载中，网络异常或加载延长，请稍后！': 'Design options loading — network delay detected, please wait!',
  '羊毛系列': 'Wool',
  '羊绒': 'Cashmere',
  '美元金额': '$X,XXX.XX',
  '翻边': 'Turn-up',
  '考勤扣款': 'Attendance Deduction',
  '考核指标': 'KPI',
  '耸肩袖（标配垫肩 + 有棉条）': 'Roped Shoulder (Standard padded)',
  '联系': 'Contact',
  '联系人': 'Contact',
  '联系电话': 'Contact Phone',
  '肚围': 'Large Belly',
  '股东分红比例': 'Shareholder Dividend Ratio',
  '肥大': 'Loose',
  '肩型': 'Shoulder',
  '肩宽': 'Shoulder Width',
  '肩斜度需复核': 'Shoulder slope needs review',
  '背带扣': 'Suspender Buttons',
  '背面图': 'Back',
  '胸围': 'Chest',
  '胸袋上刺绣': 'Chest Pocket Embroidery',
  '脚口': 'Hem Opening',
  '脚口型': 'Trouser Bottom',
  '脚腕围': 'Ankle',
  '腰围': 'Waist',
  '腰椎前凸': 'Sway Back',
  '腰面+侧缝顺色哑光色丁 1.5cm': 'Waistband + Side Matching Matte Satin 1.5cm',
  '腰面+侧缝顺色哑光色丁 2.5cm': 'Waistband + Side Matching Matte Satin 2.5cm',
  '腰面+侧缝黑色哑光色丁 1.5cm': 'Waistband + Side Black Matte Satin 1.5cm',
  '腰面+侧缝黑色哑光色丁 2.5cm': 'Waistband + Side Black Matte Satin 2.5cm',
  '腰面顺色哑光色丁': 'Waistband Matching Matte Satin',
  '腰面黑色哑光色丁': 'Waistband Black Matte Satin',
  '腰高': 'Waist Height',
  '腰高习惯': 'Waist Height Preference',
  '腿根围': 'Thigh',
  '膝围': 'Knee',
  '膝盖围': 'Knee',
  '臀围': 'Hip',
  '自动调整刺绣高度': 'Auto Height',
  '自定义': 'Custom',
  '自定义部位': 'Custom Part',
  '自由选择款式细节，完全个性化定制': 'Freely choose style details, fully personalized customization',
  '至少选择一个品类': 'Select one category',
  '舒适': 'Relaxed',
  '节节高升': 'Rising Success',
  '英寸': 'Inch',
  '英尺': 'ft/in',
  '英文': 'English',
  '草稿': 'Temp Orders',
  '获取付款信息失败': 'Failed to get payment info',
  '获取发票信息失败': 'Failed to get invoice info',
  '获取商品失败': 'Failed to get products',
  '获取订单列表失败': 'Fetch orders failed',
  '获取订单详情失败': 'Fetch details failed',
  '蓝色': 'Blue',
  '蓝色纯棉': 'Blue Cotton',
  '蓝色纯棉里布': 'Blue Cotton Lining',
  '藏青里布': 'Navy Lining',
  '行政人员': 'Admin Staff',
  '行政提成（元/单）': 'Admin Commission (CNY/order)',
  '衣长': 'Front Length',
  '前衣长': 'Front Length',
  '表袋设计': 'Watch Pocket',
  '衬衫': 'Dress Shirt',
  '衬衫下摆造型': 'Shirt Hem Style',
  '衬衫其它设计': 'Other Shirt Options',
  '衬衫刺绣位置': 'Shirt Embroidery Placement',
  '衬衫商标': 'Shirt Label',
  '衬衫尺寸': 'Shirt',
  '衬衫撞色': 'Shirt Contrast',
  '衬衫胸袋设计': 'Shirt Chest Pocket',
  '衬衫袖口设计': 'Shirt Cuff Style',
  '衬衫设计': 'Shirt Design',
  '衬衫设计尺寸': 'Shirt Design Size',
  '衬衫部位': 'Part',
  '衬衫门襟设计': 'Shirt Placket',
  '袖口': 'Cuff',
  '袖口款式': 'Cuff Vent',
  '袖口钉扣线': 'Sleeve Button Thread',
  '袖口锁眼线': 'Sleeve Buttonhole Thread',
  '袖口高度': 'Cuff Height',
  '袖型': 'Sleeve Type',
  '袖笼合缝': 'Sleeve Attachment',
  '袖肥': 'Biceps',
  '短袖长': 'Short Sleeve Length',
  '肚高': 'Belly Height',
  '下摆': 'Hem',
  '臂围': 'Upper Arm',
  '袖里': 'Sleeve Lining',
  '袖长': 'Sleeve Length',
  '裙型': 'Style',
  '裙装设计尺寸': 'Skirt Design Size',
  '裙长': 'Skirt Length',
  '裤侧缝贡针': 'Side Seam Pick Stitch',
  '裤侧袋': 'Side Pockets',
  '裤内长': 'Inseam',
  '裤后口袋': 'Back Pockets',
  '裤子刺绣位置': 'Trouser Embroidery Placement',
  '裤子尺寸': 'Trousers',
  '裤子撞色部位': 'Trouser Contrast Placement',
  '裤子款式习惯': 'Trousers Style Habit',
  '裤子订扣线': 'Trouser Button Thread',
  '裤子订标位置': 'Trouser Label Placement',
  '裤子贡针': 'Trouser Pick Stitch',
  '裤子锁眼线': 'Trouser Buttonhole Thread',
  '裤脚': 'Cuff',
  '裤腰': 'Pant Waist',
  '裤腰头': 'Waistband Extension',
  '裤腰里': 'Waistband Inside',
  '裤腰面': 'Waistband Style',
  '裤腰高': 'Waistband Width',
  '裤臀围': 'Pant Hip',
  '裤装设计尺寸': 'Trousers Design Size',
  '裤褶': 'Trouser Pleats',
  '裤调节袢': 'Belt Loops',
  '裤里位置': 'Trouser Lining Placement',
  '裤里布': 'Trouser Lining',
  '裤长': 'Pant Length',
  '裤门襟': 'Trouser Fly',
  '西装上衣': 'Jacket',
  '西裤': 'Trousers',
  '西裤 + 马甲': 'Trousers + Vent',
  '西裤+马甲': 'Trousers + Vent',
  '西裤设计': 'Trousers Design',
  '西裤部位': 'Part',
  '要求交期': 'Requested Date',
  '规格': 'Specification',
  '规格型号': 'Spec&Model',
  '角色管理': 'Roles',
  '警戒库存': 'Minimum',
  '归档面料单价': 'Archived Fabric Price',
  '汇率': 'Exchange Rate',
  '耗料量': 'Fabric Usage',
  '归档加工费': 'Archived Processing Fee',
  '费用构成': 'Cost Breakdown',
  '个性项收费': 'Personalized Item Fee',
  '计算公式': 'Formula',
  '计费单位': 'Unit',
  '计费方式': 'Charge Type',
  '订单': 'Order',
  '订单价格表': 'Order Price List',
  '订单信息': 'Order Info',
  '订单创建成功': 'Created',
  '订单号': 'Order #',
  '订单实时追踪': 'Real-time Track',
  '订单尺寸汇总': 'Measurements Summary',
  '订单已创建，折扣审批已提交': 'Order created, discount approval submitted',
  '订单已取消': 'Cancelled',
  '订单已复制': 'Order copied',
  '订单已提交': 'Submitted',
  '订单总额': 'Total Amount',
  '费用汇总': 'Fee Summary',
  '暂无明细': 'No details',
  '订单提交失败，请稍后重试。': 'Something went wrong. Please try again.',
  '订单数量': 'Quantity',
  '订单概要': 'Summary',
  '订单流水': 'Transaction History',
  '订单消耗': 'Used in Order',
  '订单状态': 'Status',
  '订单确认': 'Review & Place',
  '订单记录': 'Order History',
  '订单详情': 'Order Details',
  '订单详情时间': 'MM/DD/YYYY, h:mm A',
  '订单金额': 'Amount',
  '订单需求': 'For Order',
  '订单面料': 'Fabric',
  '订单驳回': 'Order Rejected',
  '订标位置': 'Label Placement',
  '订标线': 'Label Thread',
  '订标线颜色': 'Label Thread Color',
  '让步接收': 'Accept As-Is',
  '记录时间': 'Recorded At',
  '设为常用': 'Set as Default',
  '设置': 'Settings',
  '设计师评分': 'Rate My Designer',
  '设计选项': 'Design Options',
  '设计项': 'Design Items',
  '设计风格': 'Design Style',
  '试身': 'Fitting',
  '试身要求': 'Fitting Type',
  '试身费': 'Fitting Fee',
  '该操作当前订单状态不允许。': 'This action isn\'t available right now.',
  '该客户有以下量体档案，请选择一项导入到订单中，或关闭弹窗跳过': 'This customer has measurement records. Please select one to import into the order, or close the dialog to skip.',
  '详情': 'Details',
  '详细地址': 'Address',
  '语言': 'Language',
  '语言配置': 'Language',
  '请从左侧选择设计项': 'Please select design items from the left',
  '请假扣款': 'Leave Deduction',
  '请填写售后类型和原因': 'Please fill in after-sales type and reason',
  '请填写驳回原因': 'Please fill in rejection reason',
  '请填写驳回原因。': 'Please provide a reason for rejection.',
  '请完善信息': 'Complete info',
  '请完善必填信息': 'Complete required',
  '请尝试刷新页面，或联系管理员处理。': 'Please try refreshing the page, or contact the administrator.',
  '请描述售后原因': 'Please describe the after-sales reason',
  '请登录您的门店账户': 'Sign in to store',
  '请确认所有信息后再提交。': 'Please review all details before placing your order.',
  '请确认新密码': 'Please confirm new password',
  '请等待管理员审批通过后，订单将继续流转。': 'Please wait for admin approval before the order continues.',
  '请输入客户姓名': 'Enter customer name',
  '请输入密码': 'Please enter password',
  '请输入当前密码': 'Please enter current password',
  '请输入折扣审批理由（必填）': 'Please enter discount approval reason (required)',
  '请输入新密码': 'Please enter new password',
  '请输入消息...': 'Please enter message...',
  '请输入用户名': 'Please enter username',
  '请选择': 'Please select',
  '请选择时区': 'Please select a timezone',
  '请选择一个订单复制。': 'Select an order to duplicate.',
  '请选择品类': 'Please select category',
  '调价原因': 'Reason',
  '调价金额不能大于订单总额。': 'Adjustment cannot exceed order total.',
  '调整原因': 'Reason',
  '调整记录': 'Adjustment History',
  '调整额度': 'Adjust Limit',
  '负责门店': 'Assigned Stores',
  '更新成功': 'Update Successful',
  '更新失败': 'Update Failed',
  '贡针位置': 'Pick Stitch Placement',
  '贡针针宽': 'Pick Stitch Width',
  '财务人员确认付款': 'Finance staff confirmed payment',
  '财务复核': 'Finance Review',
  '财务审核': 'Finance Review',
  '财务待确认': 'Pending Finance',
  '账单管理': 'Bills',
  '账号余额': 'Balance',
  '账号余额明细': 'Balance Details',
  '账号安全': 'Security',
  '账号': 'Account',
  '米兰眼': 'Milanese Buttonhole',
  '手工锁眼': 'Hand Buttonhole',
  '胚布试身(机器)': 'Trial Fitting (Machine)',
  '胚布试身(手工)': 'Trial Fitting (Hand)',
  '绣字': 'Embroidery',
  '特殊里布': 'Custom Lining',
  '账号已锁定，请 1 小时后重试。': 'Too many failed attempts. Please try again in 1 hour.',
  '账户余额': 'Account Balance',
  '账户余额 (USD)': 'Balance (USD)',
  '账户充值': 'Recharge Account',
  '货期': 'Lead Time',
  '质检员': 'Inspector',
  '质检管理': 'Quality Control',
  '质检通过': 'QC Passed',
  '购买记录': 'Purchase History',
  '购物车': 'Cart',
  '贴袋': 'Patch Pocket',
  '费用明细': 'Price list',
  '超时时间': 'Timeout (s)',
  '超过10MB限制': 'Exceeds 10MB limit',
  '跟单员': 'Order Tracker',
  '跟单提成率': 'Tracker Commission Rate',
  '身高': 'Height',
  '身高(cm)': 'Height(cm)',
  '身高超出正常范围，请检查修改。': 'Height seems unusual. Please double-check.',
  '转移工厂': 'Change Factory',
  '软衬': 'Soft Interlining',
  '输入刺绣文字': 'Enter embroidery text',
  '输入客户姓名': 'Enter customer name',
  '运单号': 'Waybill No',
  '运费': 'Shipping Cost',
  '运输中': 'In Transit',
  '运输公司名称': 'Shipping Company',
  '运输方式': 'Shipping Method',
  '运输要求': 'Shipping Method',
  '返修中': 'Repairing',
  '返修内容': 'Issue Description',
  '返修出货期': 'Expected Return Date',
  '返修单': 'Repairs',
  '返修单数量': 'Alterations',
  '返修完成': 'Repaired',
  '返修订单': 'Alteration Orders',
  '返回': 'Go Back',
  '返回上一步': 'Back',
  '返回修改': 'Back to Edit',
  '返回订单列表': 'Back to List',
  '返工': 'Rework',
  '返现': 'Cashback',
  '违规项数': 'Violation Count',
  '退出登录': 'Sign Out',
  '退款': 'Refund',
  '选择': 'Select',
  '选择量体数据': 'Select Measurement Data',
  '选择体型特征': 'Select Features',
  '选择已有客户': 'Select Customer',
  '选择门店': 'Select Store',
  '通底贴布中褶': 'Full-length Placket – Medium Tuck',
  '通底贴布大褶': 'Full-length Placket – Large Tuck',
  '通底贴布小褶（塔克）': 'Full-length Placket – Small Tuck',
  '通底贴布无褶': 'Full-length Placket – No Tuck',
  '通档': 'Crotch',
  '通用模版配置': 'Templates',
  '通知': 'Notifications',
  '待办': 'To-do',
  '提醒': 'Alert',
  '状态变更': 'Status Change',
  '成本预警': 'Cost Warning',
  '超时': 'Overtime',
  '全部已读': 'All marked as read',
  '全部标记为已读': 'Mark all as read',
  '消息详情': 'Message Detail',
  '加载中': 'Loading',
  '那不勒斯肩（垫肩 0.1cm + 单层棉条 + 小碎褶）': 'Neapolitan (0.1cm pad, light pleats)',
  '那不勒斯肩（无垫肩 + 无棉条 + 小碎褶）': 'Neapolitan (No padding, light pleats)',
  '邮箱': 'Email',
  '邮编': 'ZIP',
  '部位': 'Body Part',
  '部分付款': 'Partially Paid',
  '部分付款记录': 'Partial Payments',
  '部分发货': 'Partially Shipped',
  '配饰': 'Accessories',
  '采购中': 'Procuring',
  '采购入库': 'Material Received',
  '采购单号': 'PO #',
  '采购单状态': 'PO Status',
  '采购申请': 'Purchase Request',
  '采购申请提交成功。': 'Request submitted.',
  '采购目的': 'Purpose',
  '采购类型': 'Material Type',
  '采购记录': 'Purchase Orders',
  '里布': 'Lining',
  '里布材质': 'Lining',
  '里布造型': 'Lining Style',
  '里袋撞色': 'Inner Pocket Contrast',
  '里门襟竖向刺绣': 'Inner Fly Vertical Embroidery',
  '重新推送': 'Retry',
  '重置': 'Clear',
  '重试次数': 'Retry Count',
  '量体人': 'Measured By',
  '量体定制': 'Made-to-Measure (MTM)',
  '量体尺寸': 'Measurements',
  '量体日期': 'Measured On',
  '量体档案添加成功': 'Profile added',
  '金属扣': 'Metal Button',
  '金属裤钩': 'Metal Hook & Bar',
  '金额': 'Amount',
  '铅笔裙': 'Pencil Skirt',
  '银色': 'Silver',
  '销售业绩统计': 'Sales Performance',
  '销售价格体系配置': 'Pricing Rules',
  '销售价格表': 'Sales Price List',
  '销售价（USD）': 'Sale Price (USD)',
  '错缝上袖': 'Offset Set-in Sleeve',
  '长圆头廓尔格腰头（单向）': 'Long Round Gurkha Extension (Single-side)',
  '长圆头拉廓尔格腰头（双向）': 'Long Round Gurkha Extension (Both-sides)',
  '长小圆头廓尔格腰头（单向）': 'Long Small Round Gurkha Extension (Single-side)',
  '长小圆头拉廓尔格腰头（双向）': 'Long Small Round Gurkha Extension (Both-sides)',
  '长度': 'Length',
  '长款': 'Long',
  '长短': 'Length',
  '长短要求': 'Length Preference',
  '长袖': 'Long Sleeve',
  '长裙': 'Long Skirt',
  '长青系列': 'Evergreen',
  '门幅': 'Width',
  '门店': 'Store',
  '门店 ID': 'Store ID',
  '门店Logo': 'Store Logo',
  '门店信息': 'Store Info',
  '门店列表': 'Store List',
  '门店名称': 'Store Name',
  '门店对账单': 'Store Statements',
  '门店提交审核': 'Store submitted for review',
  '门店端': 'Store Portal',
  '门店编号': 'Store Code',
  '门店订单管理系统': 'Order Management',
  '门店详情': 'Store Details',
  '门襟+袋侧缝+裤侧缝贡针': 'Fly + Pocket + Side Seam Pick Stitch',
  '门襟+袋侧缝贡针': 'Fly + Pocket Side Pick Stitch',
  '门襟扣数': 'Front Buttons',
  '门襟钉扣线': 'Front Button Thread',
  '门襟锁眼线': 'Front Buttonhole Thread',
  '问题描述': 'Description',
  '问题解决': 'Problem-Solving Ability',
  '防静电浅色条': 'Anti-static Light Stripe',
  '防静电深色条': 'Anti-static Dark Stripe',
  '附加费用': 'Surcharge',
  '随时查看订单生产进度': 'Track progress',
  '随货发': 'Ship with Order',
  '隐藏高级信息': 'Hide Advanced',
  '需修改': 'Changes Needed',
  '需处理': 'Action Required',
  '青果领': 'Shawl Collar',
  '面料': 'Fabrics',
  '面料 D': 'Fabric D',
  '面料 E': 'Fabric E',
  '面料 F': 'Fabric F',
  '面料 G': 'Fabric G',
  '面料 H': 'Fabric H',
  '面料 I': 'Fabric I',
  '面料 J': 'Fabric J',
  '面料参考': 'Fabric Reference',
  '面料号': 'Fabric No',
  '面料品牌': 'Fabric Brand',
  '面料商城': 'Fabric Mall',
  '面料图案': 'Fabric Pattern',
  '面料展示 1': 'Display 1',
  '面料展示 2': 'Display 2',
  '面料展示 3': 'Display 3',
  '面料幅宽（cm）': 'Fabric Width (cm)',
  '面料延展性考虑': 'Fabric Stretch Consideration',
  '面料归类规则': 'Fabric Grading Rules',
  '面料成本': 'Fabric Cost',
  '面料标 + 领标': 'Fabric + Neck Label',
  '面料标+领标': 'Fabric Label + Collar Label',
  '面料标在右': 'Fabric Label Right',
  '面料标在左': 'Fabric Label Left',
  '面料标订下里襟': 'Fabric Label on Under Placket',
  '面料标订后复势': 'Fabric Label on Back Yoke',
  '面料标订后复势+商标订下里襟': 'Fabric on Back Yoke + Brand on Under Placket',
  '面料款式数': 'Fabric Styles',
  '面料纹路': 'Fabric Pattern',
  '面料编号': 'Fabric Code',
  '面料选择': 'Fabric',
  '面料选择进度': 'Fabric Progress',
  '面料颜色': 'Fabric Color',
  '页面出现错误': 'Page Error',
  '页面设置': 'Page Settings',
  '页面资源已更新': 'Page Resources Updated',
  '项': 'Items',
  '顺丰': 'SF Express',
  '顺色无防滑腰里': 'Matching Standard',
  '顺色防滑腰里': 'Matching Anti-slip',
  '顺面料色': 'Match Fabric',
  '预估费用': 'Estimated Cost',
  '预估总价': 'Estimated Total',
  '预估费用明细': 'Cost Details',
  '预计交期': 'Est. Delivery',
  '预计日期': 'Est. Date',
  '预计到达': 'Est. Arrival',
  '预计发货日期': 'Est. Ship Date',
  '预计完成': 'Est. Completion',
  '预计完成日期': 'Est. Finished Date',
  '领、袖衬': 'Collar & Cuff Interlining',
  '领围': 'Neck',
  '领型': 'Collar Style',
  '领型设计': 'Collar Style',
  '领子+驳头': 'Collar + Lapel',
  '领子+驳头+下口袋牙边': 'Collar + Lapel + Pocket Piping',
  '领子+驳头+下口袋牙边+外翻袖口': 'Collar + Lapel + Pocket Piping+ Turn-back Cuff',
  '领子+驳头+下口袋牙边+胸口袋': 'Collar + Lapel + Pocket Piping+ Chest Pocket',
  '领尖双层订暗扣': 'Collar Point Double Layer Hidden Button',
  '领尖小袢订暗扣': 'Collar Point Tab + Hidden Button',
  '领尖款式': 'Collar Point Style',
  '领尖订明扣': 'Collar Point Button (Visible)',
  '领尖长': 'Collar Point Length',
  '领带': 'Ties',
  '领底尼': 'Under Collar Felt',
  '领座设计': 'Collar Stand',
  '领结': 'Bow Ties',
  '领针锁圆头眼': 'Collar Pin Buttonhole',
  '颜色': 'Color',
  '额外奖励': 'Extra Bonus',
  '额外收费': '+ Extra',
  '额外费用': 'Extra Cost',
  '风格偏好': 'Style Pref',
  '首扣距离': 'First Button Position',
  '首页': 'Home',
  '马甲': 'Waistcoat / Vest',
  '马甲下摆设计': 'Vest Hem',
  '马甲专用料': 'Vest Fabric',
  '马甲侧叉': 'Vest Side Vent',
  '马甲口袋': 'Vest Pockets',
  '马甲后背腰带': 'Back Belt',
  '马甲后领': 'Vest Back Collar',
  '马甲商标': 'Vest Label',
  '马甲尺寸': 'Vest',
  '马甲设计': 'Vest Design',
  '裙装设计': 'Skirt Design',
  '马甲设计尺寸': 'Vest Design Size',
  '马甲贡针': 'Vest Pick Stitch',
  '马甲贡针线': 'Vest Pick Stitch Thread',
  '马甲部位': 'Part',
  '马甲门襟扣数': 'Vest Front Buttons',
  '马甲驳头型': 'Vest Lapel',
  '马甲驳头宽度': 'Vest Lapel Width',
  '马蹄脚口': 'Horseshoe Hem',
  '驳回': 'Reject',
  '驳回订单': 'Reject Order',
  '驳头': 'Lapel',
  '驳头+下口袋牙边': 'Lapel + Pocket Piping',
  '驳头+下口袋牙边+胸袋': 'Lapel + Pocket Piping+ Chest Pocket',
  '驳头型': 'Lapel',
  '驳头宽': 'Lapel Width',
  '驳头眼配置': 'Lapel Buttonhole',
  '驳头眼锁眼线': 'Lapel Buttonhole Thread',
  '驳头眼长度': 'Lapel Buttonhole Length',
  '高度': 'Height',
  '高端档': 'HIGH-END',
  '高端档（高）': 'HIGH-END (High)',
  '高级工艺': 'Premium',
  '高腰': 'High Rise',
  '黑名单': 'Blacklisted',
  '黑色无防滑腰里': 'Black Standard',
  '黑色里布': 'Black Lining',
  '黑色防滑腰里': 'Black Anti-slip',
  '下口袋': 'Lower Pocket',
  '下口袋袋盖': 'Lower Pocket Flap',
  '下摆设计': 'Hem Design',
  '下摆造型': 'Hem Shape',
  '侧叉': 'Side Vent',
  '其它设计': 'Other Design',
  '后背腰带': 'Back Belt',
  '后领': 'Back Collar',
  '撞色部位': 'Contrast Part',
  '纽扣选择': 'Button Choice',
  '线色号': 'Thread Color Code',
  '胸口袋': 'Breast Pocket',
  '胸袋设计': 'Chest Pocket Design',
  '袖口设计': 'Cuff Design',
  '袖型（长短袖）': 'Sleeve Type',
  '袖扣数量': 'Sleeve Button Count',
  '订扣线': 'Button Thread',
  '调节袢/裤袢': 'Waist Adjuster',
  '贡针': 'Pick Stitch',
  '贡针线': 'Pick Stitch Thread',
  '选择款号': 'Style Number',
  '里布选择': 'Lining Choice',
  '锁眼线': 'Buttonhole Thread',
  '门襟设计': 'Front Placket Design',
  '驳头宽度': 'Lapel Width',
  '驳头眼': 'Lapel Buttonhole',
  '默认': 'Default',
  '默认合缝上袖': 'Standard Set-in Sleeve',
  '默认工厂': 'Primary Factory',
  '默认左驳头眼': 'Left Lapel Only',
  '龙角型': 'Dragon Horn Shape Milanese',
  '全麻衬工艺': 'Full Canvas',
  '粘合衬工艺': 'Fused Canvas',
  '包装': 'Packaging',
  '经典': 'Classic',
  '现代': 'Modern',
  '休闲': 'Casual',
  '羊毛': 'Wool',
  '棉': 'Cotton',
  '真丝': 'Silk',
  '粘胶': 'Viscose',
  '盖袋': 'Flap Pocket',
  '四粒扣': '4 Buttons',
  '五粒扣': '5 Buttons',
  '同面料': 'Same Fabric',
  '尖领': 'Point Collar',
  '纽扣式': 'Button Cuff',
  '法式': 'French',
  '礼盒': 'Gift Box',
  '手提袋': 'Bag',
  '首字母': 'Initials',
  '系统里布': 'System Lining',
  '系统纽扣': 'System Buttons',
  '客供纽扣': 'Client-supplied Buttons',
  '添加里布': 'Add Lining',
  '添加纽扣': 'Add Buttons',
  '客供里布（CMT来料加工）：由客户自行提供里布，发票中里布费用为零，仅计工艺加工费。请填写每块里布的物流信息。': 'Custom lining (CMT): Client provides lining. Lining cost is zero on invoice, only processing fee is charged. Please fill in logistics info for each lining.',
  '客供纽扣（CMT来料加工）：由客户自行提供纽扣，发票中纽扣费用为零，仅计工艺加工费。请填写每包纽扣的物流信息。': 'Custom buttons (CMT): Client provides buttons. Button cost is zero on invoice, only processing fee is charged. Please fill in logistics info for each package.',
  '包': 'Pack',
  '颗': 'Piece',
  '纹路/花色': 'Pattern/Color',
  '幅宽（cm）': 'Width (cm)',
  '财务人员驳回': 'Rejected by Finance',
  '待采面料': 'To-be-purchased Fabric',
  '邮寄面料': 'Mailed Fabric',
  'AI预览图生成失败': 'AI preview generation failed',
  'AI预览图生成请求已发送': 'AI preview generation request sent',
  'Logo已删除': 'Logo deleted',
  '上衣': 'Upper Body',
  '两次密码不一致': 'Passwords do not match',
  '个类型': 'types',
  '仅复用尺寸': 'Reuse measurements only',
  '保持修改并提交': 'Keep changes and submit',
  '保存失败': 'Save failed',
  '保存客户档案': 'Save customer profile',
  '保存草稿失败，无法生成AI预览图': 'Draft save failed, unable to generate AI preview',
  '修改订单': 'Edit Order',
  '关联订单': 'Related Orders',
  '付款金额': 'Payment Amount',
  '关联发票': 'Related Invoice',
  '暂无物流记录': 'No logistics records',
  '入库': 'Inbound',
  '出库': 'Outbound',
  '单号': 'Tracking No.',
  '转账方式': 'Transfer Method',
  '创建客户失败': 'Failed to create customer',
  '删除失败': 'Delete failed',
  '删除成功': 'Deleted successfully',
  '发票文件': 'Invoice File',
  '发票详情': 'Invoice Details',
  '发票金额': 'Invoice Amount',
  '基础信息': 'Basic Info',
  '处理中...': 'Processing...',
  '客户量体档案': 'Customer Measurement Profile',
  '密码至少6位': 'Password must be at least 6 characters',
  '对齐': 'Align',
  '已付清': 'Paid in full',
  '已加载客户及量体数据': 'Customer and measurement data loaded',
  '已复用客户信息': 'Customer info reused',
  '已复用尺寸信息': 'Measurement info reused',
  '已复用款式信息': 'Style info reused',
  '已有账号？': 'Already have an account?',
  '廓形': 'Silhouette',
  '按标签筛选': 'Filter by tag',
  '暂无标签': 'No Tags',
  '搜索客户': 'Search customer',
  '是否将当前客户的信息和量体数据保存到客户档案？': 'Save current customer info and measurements to customer profile?',
  '暂无备注信息': 'No remarks',
  '未付金额': 'Unpaid Amount',
  '付款时间': 'Payment Time',
  '注册': 'Register',
  '注册失败': 'Registration failed',
  '注册成功，请等待门店管理员审核': 'Registration successful, please wait for store admin approval',
  '注册成功，请等待业务员审核': 'Registration successful, please wait for designer review',
  '注册账号': 'Register Account',
  '填写信息并由业务员审核': 'Fill in info and wait for designer review',
  '所属业务员账号': 'Your Designer Account',
  '请输入所属业务员账号': 'Please enter your designer account',
  '请输入负责您的业务员账号': 'Please enter your designer account',
  '无门店可不填，由业务员分配': 'Optional; designer will assign store if empty',
  '请输入门店名称，无门店可不填': 'Please enter store name (optional)',
  '物流备注': 'Shipping Note',
  '用户名至少3位': 'Username must be at least 3 characters',
  '确认删除？': 'Confirm delete?',
  '确认密码': 'Confirm Password',
  '立即登录': 'Login now',
  '纽扣品牌': 'Button Brand',
  '纽扣幅宽（cm）': 'Button Width (cm)',
  '纽扣纹路': 'Button Pattern',
  '纽扣编号': 'Button Code',
  '编辑量体档案': 'Edit Measurement Profile',
  '获取发票详情失败': 'Failed to get invoice details',
  '获取客户尺寸失败': 'Failed to get customer measurements',
  '裤子': 'Trousers',
  '订单已被驳回': 'Order has been rejected',
  '订单量体数据': 'Order Measurement Data',
  '设计项加载中，请稍候': 'Design items loading, please wait',
  '该客户暂无尺寸档案': 'This customer has no measurement profile',
  '请再次输入密码': 'Please enter password again',
  '请确认密码': 'Please confirm password',
  '请输入档案名称': 'Please enter profile name',
  '请输入电话': 'Please enter phone',
  '请输入真实姓名': 'Please enter real name',
  '请输入身高': 'Please enter height',
  '请输入身高和体重': 'Please enter height and weight',
  '请输入邮箱': 'Please enter email',
  '请选择门店': 'Please select store',
  '跳过': 'Skip',
  '还没有账号？': "Don't have an account?",
  '选择门店并绑定账号': 'Select store and bind account',
  '里布品牌': 'Lining Brand',
  '里布幅宽（cm）': 'Lining Width (cm)',
  '里布纹路': 'Lining Pattern',
  '里布编号': 'Lining Code',
  '量体档案': 'Measurement Profile',
  '量体档案更新成功': 'Measurement profile updated successfully',
  '量体档案详情': 'Measurement Profile Details',
  '门店重新提交': 'Store resubmitted',
  '面料物流': 'Fabric Logistics',
  '驳回图片': 'Rejection Images',
  '代采': 'Purchasing Agent',
  '客供面料（代采）': 'Customer Fabric (Purchasing Agent)',
  '客供面料（客供）': 'Customer Fabric (Customer Provided)',
  '客供里布（代采）': 'Customer Lining (Purchasing Agent)',
  '客供里布（客供）': 'Customer Lining (Customer Provided)',
  '客供纽扣（代采）': 'Customer Button (Purchasing Agent)',
  '客供纽扣（客供）': 'Customer Button (Customer Provided)',
  '客供面料（待采）': 'Customer Fabric (To Be Sourced)',
  '客供里布（待采）': 'Customer Lining (To Be Sourced)',
  '客供纽扣（待采）': 'Customer Button (To Be Sourced)',
  '客供面料（邮寄）': 'Customer Fabric (Mailed)',
  '客供里布（邮寄）': 'Customer Lining (Mailed)',
  '客供纽扣（邮寄）': 'Customer Button (Mailed)',
  'No Logo': 'No Logo',
  '加载基础数据失败': 'Failed to load base data',
  '财务经理': 'Finance Manager',
  '门店经理': 'Store Manager',
  '经理': 'Manager',
  '最终价格以发票为准': 'Final price subject to invoice',
  '此价格为预估价格，不含运费和可能存在的其它费用，最终以正式发票为准': 'This is an estimated price, excluding shipping and other possible fees. The final price is subject to the official invoice.',
  '此价格为预估价格，最终以正式发票为准': 'This is an estimated price. The final price is subject to the official invoice.',

  // === merged from user/en-US.ts ===
  '体型与款式': 'Body & Style',
  '确定删除该草稿?': 'Delete this draft?',
  '用户删除草稿': 'Draft deleted by user',
  '关联发票号': 'Invoice No.',
  '订单品类': 'Category',
  '发票总额': 'Invoice Total',
  '发票创建日期': 'Invoice Date',
  '订单号/客户名/发票号': 'Order No / Customer / Invoice No',
  '下单起': 'From',
  '下单止': 'To',
  '总订单量': 'Total Orders',
  '本年订单量': 'This Year',
  '上年订单量': 'Last Year',
  '发票总金额': 'Total Invoice',
  '已付款总额': 'Total Paid',
  '未付款总额': 'Total Unpaid',
  '发票信息加载中，请稍后重试': 'Invoice info is loading, please retry later',
  '消费总金额': 'Total Spent',
  '消费总订单量': 'Total Orders',
  '创建日期': 'Created Date',
  '消费记录': 'Purchase History',
  '客户星级': 'Customer Rating',
  '星级': 'Rating',
  '体型照片': 'Body Photos',
  '备注留言': 'Notes',
  '添加留言': 'Add Note',
  '输入留言内容': 'Enter note content',
  '请输入留言或上传图片': 'Please enter note content or upload image',
  '确定删除该留言?': 'Delete this note?',
  '暂无留言': 'No notes',
  '注册日期': 'Registration Date',
  '搜索姓名/电话/邮箱': 'Search name / phone / email',
  '请输入地址': 'Please enter address',
  '创建成功': 'Created successfully',
  '添加失败': 'Add failed',
  '添加成功': 'Added successfully',
  '上传成功': 'Upload successful',
  '订单提醒': 'Order Reminder',
  '系统升级': 'System Upgrade',
  '待办事宜': 'To-Do',
  '超时提醒': 'Overtime Alert',
  '发票更新': 'Invoice Update',
  '催款提醒': 'Payment Reminder',
  '折扣消息': 'Discount Notice',
  '限时折扣': 'Flash Sale',
  '日常消息': 'Daily Notice',
  '用户姓名': 'Full Name',
  '店铺名': 'Store Name',
  '请输入您的姓名': 'Please enter your full name',
  '请输入店铺名称': 'Please enter store name',
  '请输入用户姓名': 'Please enter your full name',
  '请输入店铺名': 'Please enter store name',
  '填写信息完成门店注册': 'Fill in info to complete store registration',
  '注册成功': 'Registration Successful',
  '请妥善保存以下信息': 'Please save the following information',
  '系统登录账号': 'Login Account',
  '服务设计师': 'Your Designer',
  '登录账号与门店编号相同，请使用注册时设置的密码登录': 'Your login account is the same as your store number. Please use the password you set during registration.',
  '登录账号与门店编号相同。账号需由业务员激活后才能登录，请联系您的业务员激活': 'Your login account is the same as your store number. Your account must be activated by your designer before logging in. Please contact your designer.',
  '设计师账号不存在，请输入正确的设计师名称': 'Designer account not found. Please enter the correct designer name.',
  '账号未激活或已被禁用，请联系业务员激活': 'Your account is not activated or has been disabled. Please contact your designer to activate it.',
  '价格待确认，请联系设计师': 'Price pending confirmation, please contact your designer',
  '发票总额（最终金额）': 'Invoice Total (Final Amount)',
  '该订单发票金额': 'Invoice Amount (This Order)',
  '关联发票总金额': 'Invoice Total (All Orders)',
  '含该发票所有订单': 'includes all orders on this invoice',
  '转账手续费': 'Transfer Fee',
  '价格待确认：未设置面料价格档，当前价格仅含加工费，请设置价格档后重新计算': 'Price pending: No fabric price tier set. Current price only includes labour cost. Please set price tier and recalculate.',
  '已入账': 'Reconciled',
  '发票状态': 'Invoice Status',
  '订单付款': 'Order Payment',
  '应付': 'Amount Due',
  '已付': 'Paid',
  '未付': 'Unpaid',
  '项目': 'Item',
  '手续费': 'Handling Fee',
  '合计': 'Total',
  '该订单尚未生成发票，暂无费用明细': 'No invoice generated for this order yet',
  '附加费用明细': 'Fee Breakdown',
  '该订单的尺寸数据已被他人修改，请刷新页面后重试': 'The measurements of this order were modified by someone else. Please refresh the page and try again.',
  '功能已更新': 'Update Available',
  '当前页面是旧版本，点击刷新即可使用最新功能（未提交的内容会自动保留）': 'This page is running an older version. Refresh to use the latest features. (Unsaved data will be kept.)',
  '立即刷新': 'Refresh Now',
  '自动保存失败，请点「暂存」手动保存或刷新页面': 'Auto-save failed. Click "Temp Save" to save manually, or refresh the page.',

  // ── 注册页：业务员账号改为选填（2026-10-09）──
  '选填：知道负责您的业务员账号可填写，将由我们为您对接；留空则由客服为您分配': 'Optional: enter your salesperson\'s account if you know it and we will connect you; leave blank and our support team will assign one for you',
  '选填，请输入负责您的业务员账号': 'Optional — your salesperson\'s account',

  // ── 注册页：客户地址 / 联系我们（2026-10-10）──
  '客户地址': 'Address',
  '请输入客户地址': 'Enter your address',
  '联系我们': 'Contact Us',

  // ── 新建/编辑订单面料选择：品牌/样本册实时搜索下拉（2026-11-03）──
  '按品牌搜索': 'Search by Brand',
  '按样本册搜索': 'Search by Sample Book',
};
